var _mask, _mask2, _mask3, _mask4, _mask5, _mask6, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfographics1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 514.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 330.53,
    y: 150.57,
    width: 16.3,
    height: 16.3,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m346.83,165.51v-13.59c0-.75-.6-1.36-1.36-1.36h-13.59c-.75,0-1.36.61-1.36,1.36v13.59c0,.75.61,1.36,1.36,1.36h13.59c.76,0,1.36-.61,1.36-1.36",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 457.92,
    y: 150.57,
    width: 16.61,
    height: 16.3,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m474.4,165.51v-13.59c0-.75-.61-1.36-1.36-1.36h-13.59c-.75,0-1.36.61-1.36,1.36v13.59c0,.75.61,1.36,1.36,1.36h13.59c.75,0,1.36-.61,1.36-1.36",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.31,
    y: 201.06,
    width: 862.34,
    height: 1.36,
    style: {
      fill: "#444"
    }
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: -159.77,
    y: -578.88,
    width: 1304.21,
    height: 3260.53,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a7bd3e2bfb"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -159.77,
    y: -578.88,
    width: 1304.21,
    height: 3260.53
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.2,
    y: 200.02,
    width: 864.04,
    height: 3.62,
    style: {
      fill: "#444"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.31,
    y: 201.06,
    width: 862.34,
    height: 1.36,
    style: {
      fill: "#444"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.31,
    y: 249.79,
    width: 862.34,
    height: 1.36,
    style: {
      fill: "#444"
    }
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: -159.77,
    y: -578.88,
    width: 1304.21,
    height: 3260.53,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f77da6e25a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -159.77,
    y: -578.88,
    width: 1304.21,
    height: 3260.53
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.2,
    y: 248.93,
    width: 864.04,
    height: 3.62,
    style: {
      fill: "#444"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.31,
    y: 249.79,
    width: 862.34,
    height: 1.36,
    style: {
      fill: "#444"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.31,
    y: 298.52,
    width: 862.34,
    height: 1.36,
    style: {
      fill: "#444"
    }
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: -159.77,
    y: -578.88,
    width: 1304.21,
    height: 3260.53,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_194635abd3",
    "data-name": "194635abd3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -159.77,
    y: -578.88,
    width: 1304.21,
    height: 3260.53
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.2,
    y: 297.84,
    width: 864.04,
    height: 3.62,
    style: {
      fill: "#444"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.31,
    y: 298.52,
    width: 862.34,
    height: 1.36,
    style: {
      fill: "#444"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.31,
    y: 347.24,
    width: 862.34,
    height: 1.36,
    style: {
      fill: "#444"
    }
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: -159.77,
    y: -578.88,
    width: 1304.21,
    height: 3260.53,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b70e77bb9e"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -159.77,
    y: -578.88,
    width: 1304.21,
    height: 3260.53
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.2,
    y: 346.75,
    width: 864.04,
    height: 3.62,
    style: {
      fill: "#444"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.31,
    y: 347.24,
    width: 862.34,
    height: 1.36,
    style: {
      fill: "#444"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.31,
    y: 395.97,
    width: 862.34,
    height: 1.36,
    style: {
      fill: "#444"
    }
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    x: -159.77,
    y: -578.88,
    width: 1304.21,
    height: 3260.53,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e4c7b754dc"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -159.77,
    y: -578.88,
    width: 1304.21,
    height: 3260.53
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.2,
    y: 395.65,
    width: 864.04,
    height: 1.81,
    style: {
      fill: "#444"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.31,
    y: 395.97,
    width: 862.34,
    height: 1.36,
    style: {
      fill: "#444"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-19"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.31,
    y: 444.69,
    width: 862.34,
    height: 1.36,
    style: {
      fill: "#444"
    }
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    x: -159.77,
    y: -578.88,
    width: 1304.21,
    height: 3260.53,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_252583b5b6",
    "data-name": "252583b5b6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -159.77,
    y: -578.88,
    width: 1304.21,
    height: 3260.53
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.2,
    y: 444.56,
    width: 864.04,
    height: 1.81,
    style: {
      fill: "#444"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-21"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.31,
    y: 444.69,
    width: 862.34,
    height: 1.36,
    style: {
      fill: "#444"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-22"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.31,
    y: 422.57,
    width: 55.62,
    height: 22.8,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-23"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 215.04,
    y: 418.67,
    width: 55.62,
    height: 26.7,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 339.77,
    y: 403.76,
    width: 55.62,
    height: 41.61,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-25"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 464.51,
    y: 275.12,
    width: 55.62,
    height: 170.24,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-26"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 589.24,
    y: 206.91,
    width: 55.62,
    height: 238.45,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-27"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 713.97,
    y: 351.14,
    width: 55.62,
    height: 94.23,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-28"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 838.7,
    y: 405.71,
    width: 55.62,
    height: 39.66,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-29"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 398.11,
    y: 443.39,
    width: 55.62,
    height: 1.98,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-30"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 522.84,
    y: 443.42,
    width: 55.62,
    height: 1.95,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-31"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 647.57,
    y: 437.55,
    width: 55.62,
    height: 7.82,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-32"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 772.3,
    y: 419.85,
    width: 55.62,
    height: 25.52,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-33"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 897.04,
    y: 421.57,
    width: 55.62,
    height: 23.8,
    style: {
      fill: "none"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 514.82
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m364.72,164.16v-12.91h2.18v12.91h-2.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m373,154.68c1.17,0,2.07.28,2.72.82.66.53,1,1.3,1.02,2.32h-2.01c0-.54-.16-.95-.45-1.22-.3-.28-.74-.42-1.3-.42-.5,0-.87.11-1.13.31-.27.19-.4.45-.4.79,0,.25.06.45.2.59.15.16.35.28.62.37.26.1.69.22,1.27.37.79.19,1.4.38,1.84.57.45.17.83.45,1.16.85.32.4.48.93.48,1.58,0,.85-.35,1.54-1.05,2.07-.7.51-1.64.76-2.83.76s-2.22-.28-2.92-.85c-.7-.57-1.05-1.39-1.05-2.46h2.09c0,.57.16,1,.48,1.3.34.3.82.45,1.44.45.51,0,.91-.1,1.22-.31.3-.21.45-.48.45-.82,0-.3-.08-.54-.25-.71-.16-.18-.38-.33-.68-.42-.28-.11-.75-.24-1.39-.4-.72-.17-1.29-.33-1.7-.48-.4-.17-.75-.43-1.05-.79-.28-.38-.42-.88-.42-1.5,0-.54.15-1.03.45-1.44.3-.41.72-.74,1.27-.96.54-.24,1.17-.37,1.9-.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m383.63,154.82c.23,0,.48.04.76.11v1.81c-.25-.04-.5-.06-.74-.06-.83,0-1.46.25-1.9.76-.44.51-.65,1.25-.65,2.21v4.5h-2.07v-9.2h1.92v1.36h.03c.6-1,1.48-1.5,2.63-1.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m389.29,154.68c1.25,0,2.19.3,2.83.91.64.61.96,1.51.96,2.72v3.42c0,1,.07,1.81.23,2.43h-1.87c-.08-.38-.11-.8-.11-1.27h-.03c-.68.98-1.72,1.47-3.11,1.47-.95,0-1.7-.25-2.26-.76s-.85-1.17-.85-1.98c0-.77.26-1.39.79-1.87.54-.47,1.46-.81,2.75-1.02.77-.13,1.6-.23,2.49-.28v-.34c0-.66-.16-1.14-.48-1.44-.33-.32-.76-.48-1.33-.48s-.98.16-1.3.45c-.3.28-.47.67-.51,1.16h-2.01c.04-.91.38-1.65,1.05-2.24.66-.58,1.58-.88,2.77-.88Zm1.81,5.12c-.79.04-1.5.11-2.12.23-.67.11-1.13.28-1.42.51-.27.21-.4.52-.4.93s.14.75.42.99c.28.25.68.37,1.19.37.34,0,.65-.04.93-.14.28-.11.52-.26.74-.45.24-.26.41-.54.51-.82.09-.28.14-.67.14-1.16v-.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m399.45,162.91c.57,0,1.03-.14,1.42-.42.38-.28.61-.65.71-1.1h2.12c-.19.87-.67,1.6-1.42,2.18-.74.59-1.68.88-2.83.88-.93,0-1.73-.21-2.41-.62-.67-.43-1.17-1.02-1.53-1.75-.36-.75-.54-1.62-.54-2.6,0-.91.17-1.71.51-2.43.35-.74.86-1.31,1.53-1.73.68-.41,1.47-.62,2.38-.62,1.05,0,1.94.28,2.66.85.74.57,1.22,1.33,1.47,2.29.17.55.25,1.27.25,2.15h-6.74c.04,1,.27,1.75.71,2.24.43.47,1,.71,1.7.71Zm-.06-6.71c-.62,0-1.15.21-1.58.62-.42.42-.67,1.01-.74,1.78h4.64c-.06-.77-.3-1.37-.74-1.78-.42-.41-.95-.62-1.58-.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405.8,164.16v-12.91h2.07v12.91h-2.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496.96,151.25c1.49,0,2.63.37,3.42,1.1.79.72,1.19,1.69,1.19,2.92s-.4,2.24-1.19,2.97c-.79.72-1.94,1.08-3.42,1.08h-2.49v4.84h-2.18v-12.91h4.67Zm-2.49,6.23h2.24c.88,0,1.54-.18,1.98-.57.43-.38.65-.92.65-1.64s-.22-1.23-.65-1.61c-.44-.38-1.1-.57-1.98-.57h-2.24v4.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m506.79,154.68c1.25,0,2.19.3,2.83.91.64.61.96,1.51.96,2.72v3.42c0,1,.07,1.81.23,2.43h-1.87c-.08-.38-.11-.8-.11-1.27h-.03c-.68.98-1.72,1.47-3.11,1.47-.95,0-1.7-.25-2.26-.76s-.85-1.17-.85-1.98c0-.77.26-1.39.79-1.87.54-.47,1.46-.81,2.75-1.02.77-.13,1.6-.23,2.49-.28v-.34c0-.66-.16-1.14-.48-1.44-.33-.32-.76-.48-1.33-.48s-.98.16-1.3.45c-.3.28-.47.67-.51,1.16h-2.01c.04-.91.38-1.65,1.05-2.24.66-.58,1.58-.88,2.77-.88Zm1.81,5.12c-.79.04-1.5.11-2.12.23-.67.11-1.13.28-1.42.51-.27.21-.4.52-.4.93s.14.75.42.99c.28.25.68.37,1.19.37.34,0,.65-.04.93-.14.28-.11.52-.26.74-.45.24-.26.41-.54.51-.82.09-.28.14-.67.14-1.16v-.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m513.13,164.16v-12.91h2.07v12.91h-2.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m521.65,162.91c.57,0,1.03-.14,1.42-.42.38-.28.61-.65.71-1.1h2.12c-.19.87-.67,1.6-1.42,2.18-.74.59-1.68.88-2.83.88-.93,0-1.73-.21-2.41-.62-.67-.43-1.17-1.02-1.53-1.75-.36-.75-.54-1.62-.54-2.6,0-.91.17-1.71.51-2.43.35-.74.86-1.31,1.53-1.73.68-.41,1.47-.62,2.38-.62,1.05,0,1.94.28,2.66.85.74.57,1.22,1.33,1.47,2.29.17.55.25,1.27.25,2.15h-6.74c.04,1,.27,1.75.71,2.24.43.47,1,.71,1.7.71Zm-.06-6.71c-.62,0-1.15.21-1.58.62-.42.42-.67,1.01-.74,1.78h4.64c-.06-.77-.3-1.37-.74-1.78-.42-.41-.95-.62-1.58-.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m531.18,154.68c1.17,0,2.07.28,2.72.82.66.53,1,1.3,1.02,2.32h-2.01c0-.54-.16-.95-.45-1.22-.3-.28-.74-.42-1.3-.42-.5,0-.87.11-1.13.31-.27.19-.4.45-.4.79,0,.25.06.45.2.59.15.16.35.28.62.37.26.1.69.22,1.27.37.79.19,1.4.38,1.84.57.45.17.83.45,1.16.85.32.4.48.93.48,1.58,0,.85-.35,1.54-1.05,2.07-.7.51-1.64.76-2.83.76s-2.22-.28-2.92-.85c-.7-.57-1.05-1.39-1.05-2.46h2.09c0,.57.16,1,.48,1.3.34.3.82.45,1.44.45.51,0,.91-.1,1.22-.31.3-.21.45-.48.45-.82,0-.3-.08-.54-.25-.71-.16-.18-.38-.33-.68-.42-.28-.11-.75-.24-1.39-.4-.72-.17-1.29-.33-1.7-.48-.4-.17-.75-.43-1.05-.79-.28-.38-.42-.88-.42-1.5,0-.54.15-1.03.45-1.44.3-.41.72-.74,1.27-.96.54-.24,1.17-.37,1.9-.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m540.91,162.57c.26,0,.48-.03.65-.08v1.61c-.38.11-.76.17-1.16.17-.98,0-1.7-.21-2.15-.65-.44-.45-.65-1.17-.65-2.18v-4.9h-1.53v-1.58h1.53v-2.29h2.07v2.29h1.78v1.58h-1.78v4.59c0,.53.09.91.28,1.13.21.21.52.31.96.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m543.36,164.16v-9.2h2.07v9.2h-2.07Zm0-10.93v-1.98h2.07v1.98h-2.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m552.8,154.73c1.08,0,1.9.33,2.49.96.58.64.88,1.58.88,2.83v5.63h-2.07v-5.46c0-1.53-.62-2.29-1.87-2.29-.62,0-1.13.24-1.53.71-.38.45-.57,1.1-.57,1.95v5.09h-2.07v-9.2h1.95v1.19h.03c.3-.43.69-.77,1.16-1.02.47-.26,1-.4,1.58-.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m558.72,164.16v-9.2h2.07v9.2h-2.07Zm0-10.93v-1.98h2.07v1.98h-2.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m566.85,154.68c1.25,0,2.19.3,2.83.91.64.61.96,1.51.96,2.72v3.42c0,1,.07,1.81.23,2.43h-1.87c-.08-.38-.11-.8-.11-1.27h-.03c-.68.98-1.72,1.47-3.11,1.47-.95,0-1.7-.25-2.26-.76s-.85-1.17-.85-1.98c0-.77.26-1.39.79-1.87.54-.47,1.46-.81,2.75-1.02.77-.13,1.6-.23,2.49-.28v-.34c0-.66-.16-1.14-.48-1.44-.33-.32-.76-.48-1.33-.48s-.98.16-1.3.45c-.3.28-.47.67-.51,1.16h-2.01c.04-.91.38-1.65,1.05-2.24.66-.58,1.58-.88,2.77-.88Zm1.81,5.12c-.79.04-1.5.11-2.12.23-.67.11-1.13.28-1.42.51-.27.21-.4.52-.4.93s.14.75.42.99c.28.25.68.37,1.19.37.34,0,.65-.04.93-.14.28-.11.52-.26.74-.45.24-.26.41-.54.51-.82.09-.28.14-.67.14-1.16v-.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m577.91,154.73c1.08,0,1.9.33,2.49.96.58.64.88,1.58.88,2.83v5.63h-2.07v-5.46c0-1.53-.62-2.29-1.87-2.29-.62,0-1.13.24-1.53.71-.38.45-.57,1.1-.57,1.95v5.09h-2.07v-9.2h1.95v1.19h.03c.3-.43.69-.77,1.16-1.02.47-.26,1-.4,1.58-.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m590.21,160.65l-1.19,3.51h-2.26l4.67-12.91h2.92l4.7,12.91h-2.29l-1.19-3.51h-5.35Zm4.36-2.89c-.72-2.15-1.27-3.86-1.67-5.12h-.03c-.64,2.09-1.19,3.81-1.64,5.12l-.37,1.02h4.05l-.34-1.02Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m603.69,164.38c-1.06,0-1.88-.32-2.46-.96-.59-.64-.88-1.58-.88-2.83v-5.63h2.04v5.46c0,1.53.62,2.29,1.87,2.29.62,0,1.13-.23,1.53-.68.4-.47.59-1.13.59-1.98v-5.09h2.07v9.2h-1.98v-1.19h-.03c-.3.44-.69.79-1.16,1.05-.47.24-1,.37-1.58.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m614.76,162.57c.26,0,.48-.03.65-.08v1.61c-.38.11-.76.17-1.16.17-.98,0-1.7-.21-2.15-.65-.44-.45-.65-1.17-.65-2.18v-4.9h-1.53v-1.58h1.53v-2.29h2.07v2.29h1.78v1.58h-1.78v4.59c0,.53.09.91.28,1.13.21.21.52.31.96.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m619.32,156.04c.32-.43.71-.75,1.16-.96.45-.23.94-.34,1.47-.34,1.08,0,1.9.33,2.49.96.58.64.88,1.58.88,2.83v5.63h-2.07v-5.46c0-1.53-.62-2.29-1.87-2.29-.62,0-1.13.24-1.53.71-.38.45-.57,1.1-.57,1.95v5.09h-2.07v-12.91h2.07v4.78h.03Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m631.78,154.68c.92,0,1.73.21,2.41.62.68.4,1.2.96,1.56,1.7.38.72.57,1.57.57,2.55s-.19,1.87-.57,2.6c-.36.72-.88,1.29-1.56,1.7-.68.4-1.49.59-2.41.59s-1.74-.2-2.43-.59c-.68-.41-1.21-.98-1.58-1.7-.36-.74-.54-1.6-.54-2.6s.18-1.83.54-2.55c.38-.74.91-1.3,1.58-1.7.69-.41,1.51-.62,2.43-.62Zm0,1.64c-.74,0-1.32.3-1.75.88-.42.57-.62,1.35-.62,2.35s.21,1.83.62,2.41c.43.57,1.02.85,1.75.85s1.31-.28,1.73-.85c.43-.58.65-1.39.65-2.41s-.22-1.78-.65-2.35c-.42-.58-.99-.88-1.73-.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m642.9,154.82c.23,0,.48.04.76.11v1.81c-.25-.04-.5-.06-.74-.06-.83,0-1.46.25-1.9.76-.44.51-.65,1.25-.65,2.21v4.5h-2.07v-9.2h1.92v1.36h.03c.6-1,1.48-1.5,2.63-1.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m645.14,164.16v-9.2h2.07v9.2h-2.07Zm0-10.93v-1.98h2.07v1.98h-2.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m653.53,162.57c.26,0,.48-.03.65-.08v1.61c-.38.11-.76.17-1.16.17-.98,0-1.7-.21-2.15-.65-.44-.45-.65-1.17-.65-2.18v-4.9h-1.53v-1.58h1.53v-2.29h2.07v2.29h1.78v1.58h-1.78v4.59c0,.53.09.91.28,1.13.21.21.52.31.96.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m660.07,164.55c-.3.79-.64,1.4-.99,1.84-.34.43-.76.74-1.25.93-.47.18-1.07.28-1.78.28-.38,0-.73-.05-1.05-.14v-1.67c.28.07.57.11.88.11.54,0,.97-.13,1.27-.37.3-.25.55-.68.76-1.3l-3.37-9.28h2.21l2.32,6.85h.03l2.38-6.85h2.12l-3.54,9.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-1)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m330.53,150.57h144.01v16.3h-144.01v-16.3Z",
    style: {
      fill: "#ff5722"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-2)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-3)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m330.53,150.57h144.01v16.3h-144.01v-16.3Z",
    style: {
      fill: "#9d22ff"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m117.55,470.28v-8.58h-2.83v-1.56c.98,0,1.71-.16,2.18-.48.49-.32.79-.85.91-1.58h1.9v12.2h-2.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.05,470.56c-1.13,0-2.05-.31-2.75-.93-.7-.62-1.09-1.49-1.16-2.6h2.18c.07.59.27,1.02.59,1.3.32.28.74.42,1.25.42.79,0,1.42-.34,1.9-1.02.49-.68.75-1.71.79-3.11h-.06c-.74.95-1.7,1.42-2.89,1.42-.78,0-1.46-.17-2.07-.51-.59-.34-1.05-.81-1.39-1.42-.33-.6-.48-1.29-.48-2.07,0-.83.18-1.56.54-2.21.38-.64.89-1.14,1.56-1.5.68-.35,1.44-.54,2.29-.54,1.45,0,2.56.5,3.34,1.5.77,1,1.16,2.49,1.16,4.47,0,2.17-.42,3.85-1.27,5.04-.83,1.17-2.01,1.75-3.54,1.75Zm.28-6.2c.64,0,1.16-.23,1.56-.68s.59-1.03.59-1.73-.19-1.29-.57-1.73c-.38-.43-.9-.65-1.56-.65s-1.19.22-1.58.65c-.38.44-.57,1.02-.57,1.75s.18,1.29.57,1.73c.38.44.89.65,1.56.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.41,459.83l-.34,3.31h.03c.3-.3.66-.52,1.08-.68.43-.17.88-.25,1.36-.25.79,0,1.49.17,2.09.51.62.33,1.09.79,1.42,1.42.34.61.51,1.3.51,2.09,0,.87-.19,1.63-.57,2.29-.36.64-.88,1.15-1.56,1.5-.68.35-1.47.54-2.38.54-1.27,0-2.28-.32-3.03-.96-.76-.64-1.13-1.51-1.13-2.6h2.15c.01.55.21.98.59,1.3.38.3.85.45,1.42.45.71,0,1.27-.21,1.67-.62.4-.43.59-1.03.59-1.81s-.2-1.34-.59-1.75c-.38-.41-.91-.62-1.58-.62-.53,0-.98.13-1.33.4-.34.27-.58.64-.71,1.1l-2.12-.14.71-7.22h7.27v1.75h-5.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m149.09,470.56c-1.13,0-2.05-.31-2.75-.93-.7-.62-1.09-1.49-1.16-2.6h2.18c.07.59.27,1.02.59,1.3.32.28.74.42,1.25.42.79,0,1.42-.34,1.9-1.02.49-.68.75-1.71.79-3.11h-.06c-.74.95-1.7,1.42-2.89,1.42-.78,0-1.46-.17-2.07-.51-.59-.34-1.05-.81-1.39-1.42-.33-.6-.48-1.29-.48-2.07,0-.83.18-1.56.54-2.21.38-.64.89-1.14,1.56-1.5.68-.35,1.44-.54,2.29-.54,1.45,0,2.56.5,3.34,1.5.77,1,1.16,2.49,1.16,4.47,0,2.17-.42,3.85-1.27,5.04-.83,1.17-2.01,1.75-3.54,1.75Zm.28-6.2c.64,0,1.16-.23,1.56-.68s.59-1.03.59-1.73-.19-1.29-.57-1.73c-.38-.43-.9-.65-1.56-.65s-1.19.22-1.58.65c-.38.44-.57,1.02-.57,1.75s.18,1.29.57,1.73c.38.44.89.65,1.56.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155.53,465.83v-1.7h4.53v1.7h-4.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.22,470.56c-1.13,0-2.05-.31-2.75-.93-.7-.62-1.09-1.49-1.16-2.6h2.18c.07.59.27,1.02.59,1.3.32.28.74.42,1.25.42.79,0,1.42-.34,1.9-1.02.49-.68.75-1.71.79-3.11h-.06c-.74.95-1.7,1.42-2.89,1.42-.78,0-1.46-.17-2.07-.51-.59-.34-1.05-.81-1.39-1.42-.33-.6-.48-1.29-.48-2.07,0-.83.18-1.56.54-2.21.38-.64.89-1.14,1.56-1.5.68-.35,1.44-.54,2.29-.54,1.45,0,2.56.5,3.34,1.5.77,1,1.16,2.49,1.16,4.47,0,2.17-.42,3.85-1.27,5.04-.83,1.17-2.01,1.75-3.54,1.75Zm.28-6.2c.64,0,1.16-.23,1.56-.68s.59-1.03.59-1.73-.19-1.29-.57-1.73c-.38-.43-.9-.65-1.56-.65s-1.19.22-1.58.65c-.38.44-.57,1.02-.57,1.75s.18,1.29.57,1.73c.38.44.89.65,1.56.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.36,457.79c1.28,0,2.29.31,3.03.93.75.61,1.13,1.43,1.13,2.46,0,.7-.17,1.27-.51,1.73-.34.44-.88.79-1.61,1.05v.06c.81.27,1.39.64,1.75,1.13.38.47.57,1.1.57,1.87,0,.72-.18,1.34-.54,1.87-.36.53-.87.95-1.53,1.25-.67.28-1.42.42-2.26.42-1.44,0-2.54-.35-3.31-1.08-.78-.71-1.16-1.73-1.16-3.06h2.15c0,.78.18,1.36.57,1.75.4.38.98.57,1.75.57.64,0,1.16-.16,1.56-.48.4-.34.59-.78.59-1.33,0-1.28-.89-1.92-2.66-1.92h-.45v-1.75h.45c.77,0,1.39-.17,1.84-.51s.68-.79.68-1.36c0-.52-.2-.96-.59-1.3-.38-.34-.89-.51-1.53-.51s-1.18.19-1.56.57c-.36.36-.54.91-.54,1.64h-2.15c0-1.25.38-2.21,1.13-2.92.77-.71,1.84-1.08,3.2-1.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.29,470.28v-8.58h-2.83v-1.56c.98,0,1.71-.16,2.18-.48.49-.32.79-.85.91-1.58h1.9v12.2h-2.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m252.78,470.56c-1.13,0-2.05-.31-2.75-.93-.7-.62-1.09-1.49-1.16-2.6h2.18c.07.59.27,1.02.59,1.3.32.28.74.42,1.25.42.79,0,1.42-.34,1.9-1.02.49-.68.75-1.71.79-3.11h-.06c-.74.95-1.7,1.42-2.89,1.42-.78,0-1.46-.17-2.07-.51-.59-.34-1.05-.81-1.39-1.42-.33-.6-.48-1.29-.48-2.07,0-.83.18-1.56.54-2.21.38-.64.89-1.14,1.56-1.5.68-.35,1.44-.54,2.29-.54,1.45,0,2.56.5,3.34,1.5.77,1,1.16,2.49,1.16,4.47,0,2.17-.42,3.85-1.27,5.04-.83,1.17-2.01,1.75-3.54,1.75Zm.28-6.2c.64,0,1.16-.23,1.56-.68s.59-1.03.59-1.73-.19-1.29-.57-1.73c-.38-.43-.9-.65-1.56-.65s-1.19.22-1.58.65c-.38.44-.57,1.02-.57,1.75s.18,1.29.57,1.73c.38.44.89.65,1.56.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.3,470.56c-1.13,0-2.05-.31-2.75-.93-.7-.62-1.09-1.49-1.16-2.6h2.18c.07.59.27,1.02.59,1.3.32.28.74.42,1.25.42.79,0,1.42-.34,1.9-1.02.49-.68.75-1.71.79-3.11h-.06c-.74.95-1.7,1.42-2.89,1.42-.78,0-1.46-.17-2.07-.51-.59-.34-1.05-.81-1.39-1.42-.33-.6-.48-1.29-.48-2.07,0-.83.18-1.56.54-2.21.38-.64.89-1.14,1.56-1.5.68-.35,1.44-.54,2.29-.54,1.45,0,2.56.5,3.34,1.5.77,1,1.16,2.49,1.16,4.47,0,2.17-.42,3.85-1.27,5.04-.83,1.17-2.01,1.75-3.54,1.75Zm.28-6.2c.64,0,1.16-.23,1.56-.68s.59-1.03.59-1.73-.19-1.29-.57-1.73c-.38-.43-.9-.65-1.56-.65s-1.19.22-1.58.65c-.38.44-.57,1.02-.57,1.75s.18,1.29.57,1.73c.38.44.89.65,1.56.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m277.47,467.33v2.94h-2.15v-2.94h-5.8v-1.84l5.09-7.42h2.86v7.56h1.87v1.7h-1.87Zm-2.09-1.7v-1.58c0-1.26.03-2.7.08-4.3h-.03c-.59.96-1.46,2.31-2.63,4.02l-1.27,1.87h3.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280.26,465.83v-1.7h4.53v1.7h-4.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m289.95,470.56c-1.13,0-2.05-.31-2.75-.93-.7-.62-1.09-1.49-1.16-2.6h2.18c.07.59.27,1.02.59,1.3.32.28.74.42,1.25.42.79,0,1.42-.34,1.9-1.02.49-.68.75-1.71.79-3.11h-.06c-.74.95-1.7,1.42-2.89,1.42-.78,0-1.46-.17-2.07-.51-.59-.34-1.05-.81-1.39-1.42-.33-.6-.48-1.29-.48-2.07,0-.83.18-1.56.54-2.21.38-.64.89-1.14,1.56-1.5.68-.35,1.44-.54,2.29-.54,1.45,0,2.56.5,3.34,1.5.77,1,1.16,2.49,1.16,4.47,0,2.17-.42,3.85-1.27,5.04-.83,1.17-2.01,1.75-3.54,1.75Zm.28-6.2c.64,0,1.16-.23,1.56-.68s.59-1.03.59-1.73-.19-1.29-.57-1.73c-.38-.43-.9-.65-1.56-.65s-1.19.22-1.58.65c-.38.44-.57,1.02-.57,1.75s.18,1.29.57,1.73c.38.44.89.65,1.56.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301.12,457.79c.81,0,1.54.14,2.18.42.64.27,1.14.65,1.5,1.16.35.51.54,1.1.54,1.75s-.2,1.27-.59,1.75c-.38.47-.91.81-1.58,1.02v.06c.75.21,1.34.58,1.78,1.1.43.53.65,1.17.65,1.92s-.19,1.35-.57,1.9c-.36.53-.88.95-1.56,1.25-.68.28-1.46.42-2.35.42s-1.67-.14-2.35-.42c-.67-.3-1.18-.71-1.56-1.25-.38-.54-.57-1.17-.57-1.9s.21-1.39.65-1.92c.43-.52,1.03-.89,1.78-1.1v-.06c-.68-.21-1.22-.54-1.61-1.02-.38-.49-.57-1.08-.57-1.75s.18-1.25.54-1.75c.38-.51.88-.89,1.5-1.16.64-.28,1.37-.42,2.18-.42Zm0,1.78c-.64,0-1.16.16-1.56.48-.38.3-.57.72-.57,1.25,0,.57.18,1.01.57,1.33.38.33.89.48,1.56.48s1.17-.16,1.56-.48c.38-.32.57-.76.57-1.33,0-.52-.2-.94-.59-1.25-.38-.32-.89-.48-1.53-.48Zm0,5.29c-.68,0-1.24.18-1.67.54-.42.34-.62.81-.62,1.39s.2,1.06.59,1.42c.41.36.98.54,1.7.54s1.25-.18,1.67-.54c.43-.35.65-.83.65-1.42s-.22-1.03-.65-1.39c-.42-.35-.98-.54-1.67-.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.49,470.28v-8.58h-2.83v-1.56c.98,0,1.71-.16,2.18-.48.49-.32.79-.85.91-1.58h1.9v12.2h-2.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m366.99,470.56c-1.13,0-2.05-.31-2.75-.93-.7-.62-1.09-1.49-1.16-2.6h2.18c.07.59.27,1.02.59,1.3.32.28.74.42,1.25.42.79,0,1.42-.34,1.9-1.02.49-.68.75-1.71.79-3.11h-.06c-.74.95-1.7,1.42-2.89,1.42-.78,0-1.46-.17-2.07-.51-.59-.34-1.05-.81-1.39-1.42-.33-.6-.48-1.29-.48-2.07,0-.83.18-1.56.54-2.21.38-.64.89-1.14,1.56-1.5.68-.35,1.44-.54,2.29-.54,1.45,0,2.56.5,3.34,1.5.77,1,1.16,2.49,1.16,4.47,0,2.17-.42,3.85-1.27,5.04-.83,1.17-2.01,1.75-3.54,1.75Zm.28-6.2c.64,0,1.16-.23,1.56-.68s.59-1.03.59-1.73-.19-1.29-.57-1.73c-.38-.43-.9-.65-1.56-.65s-1.19.22-1.58.65c-.38.44-.57,1.02-.57,1.75s.18,1.29.57,1.73c.38.44.89.65,1.56.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m377.51,470.56c-1.13,0-2.05-.31-2.75-.93-.7-.62-1.09-1.49-1.16-2.6h2.18c.07.59.27,1.02.59,1.3.32.28.74.42,1.25.42.79,0,1.42-.34,1.9-1.02.49-.68.75-1.71.79-3.11h-.06c-.74.95-1.7,1.42-2.89,1.42-.78,0-1.46-.17-2.07-.51-.59-.34-1.05-.81-1.39-1.42-.33-.6-.48-1.29-.48-2.07,0-.83.18-1.56.54-2.21.38-.64.89-1.14,1.56-1.5.68-.35,1.44-.54,2.29-.54,1.45,0,2.56.5,3.34,1.5.77,1,1.16,2.49,1.16,4.47,0,2.17-.42,3.85-1.27,5.04-.83,1.17-2.01,1.75-3.54,1.75Zm.28-6.2c.64,0,1.16-.23,1.56-.68s.59-1.03.59-1.73-.19-1.29-.57-1.73c-.38-.43-.9-.65-1.56-.65s-1.19.22-1.58.65c-.38.44-.57,1.02-.57,1.75s.18,1.29.57,1.73c.38.44.89.65,1.56.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m388.03,470.56c-1.13,0-2.05-.31-2.75-.93-.7-.62-1.09-1.49-1.16-2.6h2.18c.07.59.27,1.02.59,1.3.32.28.74.42,1.25.42.79,0,1.42-.34,1.9-1.02.49-.68.75-1.71.79-3.11h-.06c-.74.95-1.7,1.42-2.89,1.42-.78,0-1.46-.17-2.07-.51-.59-.34-1.05-.81-1.39-1.42-.33-.6-.48-1.29-.48-2.07,0-.83.18-1.56.54-2.21.38-.64.89-1.14,1.56-1.5.68-.35,1.44-.54,2.29-.54,1.45,0,2.56.5,3.34,1.5.77,1,1.16,2.49,1.16,4.47,0,2.17-.42,3.85-1.27,5.04-.83,1.17-2.01,1.75-3.54,1.75Zm.28-6.2c.64,0,1.16-.23,1.56-.68s.59-1.03.59-1.73-.19-1.29-.57-1.73c-.38-.43-.9-.65-1.56-.65s-1.19.22-1.58.65c-.38.44-.57,1.02-.57,1.75s.18,1.29.57,1.73c.38.44.89.65,1.56.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m394.47,465.83v-1.7h4.53v1.7h-4.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m404.81,457.79c.81,0,1.51.14,2.12.42.62.28,1.1.69,1.44,1.22.34.51.51,1.12.51,1.81s-.13,1.27-.4,1.78c-.25.5-.59.93-1.05,1.3-.45.36-1.05.75-1.78,1.16-.78.45-1.36.84-1.75,1.16-.4.33-.67.62-.82.91-.16.28-.24.59-.25.93h6.34v1.78h-8.8v-.37c0-.85.09-1.56.28-2.15.18-.58.54-1.14,1.05-1.67.51-.54,1.25-1.09,2.21-1.64.69-.4,1.22-.74,1.58-1.02.38-.28.67-.58.88-.91.21-.34.31-.74.31-1.19,0-.52-.17-.94-.51-1.25-.34-.32-.79-.48-1.36-.48-1.36,0-2.07.72-2.12,2.15h-2.15c.01-1.26.4-2.24,1.16-2.92.75-.69,1.79-1.05,3.11-1.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m415.33,457.79c1.51,0,2.66.56,3.45,1.67.79,1.1,1.19,2.66,1.19,4.7s-.4,3.64-1.19,4.75c-.79,1.1-1.95,1.64-3.45,1.64s-2.65-.54-3.45-1.64c-.79-1.11-1.19-2.7-1.19-4.75s.4-3.6,1.19-4.7c.81-1.11,1.96-1.67,3.45-1.67Zm0,1.84c-.78,0-1.38.39-1.81,1.16-.42.78-.62,1.9-.62,3.37s.21,2.6.62,3.4c.43.79,1.03,1.19,1.81,1.19s1.37-.4,1.78-1.19c.41-.79.62-1.92.62-3.4s-.21-2.59-.62-3.37c-.42-.77-1.01-1.16-1.78-1.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m425.85,457.79c1.51,0,2.66.56,3.45,1.67.79,1.1,1.19,2.66,1.19,4.7s-.4,3.64-1.19,4.75c-.79,1.1-1.95,1.64-3.45,1.64s-2.65-.54-3.45-1.64c-.79-1.11-1.19-2.7-1.19-4.75s.4-3.6,1.19-4.7c.81-1.11,1.96-1.67,3.45-1.67Zm0,1.84c-.78,0-1.38.39-1.81,1.16-.42.78-.62,1.9-.62,3.37s.21,2.6.62,3.4c.43.79,1.03,1.19,1.81,1.19s1.37-.4,1.78-1.19c.41-.79.62-1.92.62-3.4s-.21-2.59-.62-3.37c-.42-.77-1.01-1.16-1.78-1.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m436.34,457.79c1.28,0,2.29.31,3.03.93.75.61,1.13,1.43,1.13,2.46,0,.7-.17,1.27-.51,1.73-.34.44-.88.79-1.61,1.05v.06c.81.27,1.39.64,1.75,1.13.38.47.57,1.1.57,1.87,0,.72-.18,1.34-.54,1.87-.36.53-.87.95-1.53,1.25-.67.28-1.42.42-2.26.42-1.44,0-2.54-.35-3.31-1.08-.78-.71-1.16-1.73-1.16-3.06h2.15c0,.78.18,1.36.57,1.75.4.38.98.57,1.75.57.64,0,1.16-.16,1.56-.48.4-.34.59-.78.59-1.33,0-1.28-.89-1.92-2.66-1.92h-.45v-1.75h.45c.77,0,1.39-.17,1.84-.51s.68-.79.68-1.36c0-.52-.2-.96-.59-1.3-.38-.34-.89-.51-1.53-.51s-1.18.19-1.56.57c-.36.36-.54.91-.54,1.64h-2.15c0-1.25.38-2.21,1.13-2.92.77-.71,1.84-1.08,3.2-1.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m492.37,457.79c.81,0,1.51.14,2.12.42.62.28,1.1.69,1.44,1.22.34.51.51,1.12.51,1.81s-.13,1.27-.4,1.78c-.25.5-.59.93-1.05,1.3-.45.36-1.05.75-1.78,1.16-.78.45-1.36.84-1.75,1.16-.4.33-.67.62-.82.91-.16.28-.24.59-.25.93h6.34v1.78h-8.8v-.37c0-.85.09-1.56.28-2.15.18-.58.54-1.14,1.05-1.67.51-.54,1.25-1.09,2.21-1.64.69-.4,1.22-.74,1.58-1.02.38-.28.67-.58.88-.91.21-.34.31-.74.31-1.19,0-.52-.17-.94-.51-1.25-.34-.32-.79-.48-1.36-.48-1.36,0-2.07.72-2.12,2.15h-2.15c.01-1.26.4-2.24,1.16-2.92.75-.69,1.79-1.05,3.11-1.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m502.89,457.79c1.51,0,2.66.56,3.45,1.67.79,1.1,1.19,2.66,1.19,4.7s-.4,3.64-1.19,4.75c-.79,1.1-1.95,1.64-3.45,1.64s-2.65-.54-3.45-1.64c-.79-1.11-1.19-2.7-1.19-4.75s.4-3.6,1.19-4.7c.81-1.11,1.96-1.67,3.45-1.67Zm0,1.84c-.78,0-1.38.39-1.81,1.16-.42.78-.62,1.9-.62,3.37s.21,2.6.62,3.4c.43.79,1.03,1.19,1.81,1.19s1.37-.4,1.78-1.19c.41-.79.62-1.92.62-3.4s-.21-2.59-.62-3.37c-.42-.77-1.01-1.16-1.78-1.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m513.41,457.79c1.51,0,2.66.56,3.45,1.67.79,1.1,1.19,2.66,1.19,4.7s-.4,3.64-1.19,4.75c-.79,1.1-1.95,1.64-3.45,1.64s-2.65-.54-3.45-1.64c-.79-1.11-1.19-2.7-1.19-4.75s.4-3.6,1.19-4.7c.81-1.11,1.96-1.67,3.45-1.67Zm0,1.84c-.78,0-1.38.39-1.81,1.16-.42.78-.62,1.9-.62,3.37s.21,2.6.62,3.4c.43.79,1.03,1.19,1.81,1.19s1.37-.4,1.78-1.19c.41-.79.62-1.92.62-3.4s-.21-2.59-.62-3.37c-.42-.77-1.01-1.16-1.78-1.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m526.93,467.33v2.94h-2.15v-2.94h-5.8v-1.84l5.09-7.42h2.86v7.56h1.87v1.7h-1.87Zm-2.09-1.7v-1.58c0-1.26.03-2.7.08-4.3h-.03c-.59.96-1.46,2.31-2.63,4.02l-1.27,1.87h3.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m529.73,465.83v-1.7h4.53v1.7h-4.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m540.07,457.79c1.51,0,2.66.56,3.45,1.67.79,1.1,1.19,2.66,1.19,4.7s-.4,3.64-1.19,4.75c-.79,1.1-1.95,1.64-3.45,1.64s-2.65-.54-3.45-1.64c-.79-1.11-1.19-2.7-1.19-4.75s.4-3.6,1.19-4.7c.81-1.11,1.96-1.67,3.45-1.67Zm0,1.84c-.78,0-1.38.39-1.81,1.16-.42.78-.62,1.9-.62,3.37s.21,2.6.62,3.4c.43.79,1.03,1.19,1.81,1.19s1.37-.4,1.78-1.19c.41-.79.62-1.92.62-3.4s-.21-2.59-.62-3.37c-.42-.77-1.01-1.16-1.78-1.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m550.59,457.79c.81,0,1.54.14,2.18.42.64.27,1.14.65,1.5,1.16.35.51.54,1.1.54,1.75s-.2,1.27-.59,1.75c-.38.47-.91.81-1.58,1.02v.06c.75.21,1.34.58,1.78,1.1.43.53.65,1.17.65,1.92s-.19,1.35-.57,1.9c-.36.53-.88.95-1.56,1.25-.68.28-1.46.42-2.35.42s-1.67-.14-2.35-.42c-.67-.3-1.18-.71-1.56-1.25-.38-.54-.57-1.17-.57-1.9s.21-1.39.65-1.92c.43-.52,1.03-.89,1.78-1.1v-.06c-.68-.21-1.22-.54-1.61-1.02-.38-.49-.57-1.08-.57-1.75s.18-1.25.54-1.75c.38-.51.88-.89,1.5-1.16.64-.28,1.37-.42,2.18-.42Zm0,1.78c-.64,0-1.16.16-1.56.48-.38.3-.57.72-.57,1.25,0,.57.18,1.01.57,1.33.38.33.89.48,1.56.48s1.17-.16,1.56-.48c.38-.32.57-.76.57-1.33,0-.52-.2-.94-.59-1.25-.38-.32-.89-.48-1.53-.48Zm0,5.29c-.68,0-1.24.18-1.67.54-.42.34-.62.81-.62,1.39s.2,1.06.59,1.42c.41.36.98.54,1.7.54s1.25-.18,1.67-.54c.43-.35.65-.83.65-1.42s-.22-1.03-.65-1.39c-.42-.35-.98-.54-1.67-.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m617.1,457.79c.81,0,1.51.14,2.12.42.62.28,1.1.69,1.44,1.22.34.51.51,1.12.51,1.81s-.13,1.27-.4,1.78c-.25.5-.59.93-1.05,1.3-.45.36-1.05.75-1.78,1.16-.78.45-1.36.84-1.75,1.16-.4.33-.67.62-.82.91-.16.28-.24.59-.25.93h6.34v1.78h-8.8v-.37c0-.85.09-1.56.28-2.15.18-.58.54-1.14,1.05-1.67.51-.54,1.25-1.09,2.21-1.64.69-.4,1.22-.74,1.58-1.02.38-.28.67-.58.88-.91.21-.34.31-.74.31-1.19,0-.52-.17-.94-.51-1.25-.34-.32-.79-.48-1.36-.48-1.36,0-2.07.72-2.12,2.15h-2.15c.01-1.26.4-2.24,1.16-2.92.75-.69,1.79-1.05,3.11-1.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m627.62,457.79c1.51,0,2.66.56,3.45,1.67.79,1.1,1.19,2.66,1.19,4.7s-.4,3.64-1.19,4.75c-.79,1.1-1.95,1.64-3.45,1.64s-2.65-.54-3.45-1.64c-.79-1.11-1.19-2.7-1.19-4.75s.4-3.6,1.19-4.7c.81-1.11,1.96-1.67,3.45-1.67Zm0,1.84c-.78,0-1.38.39-1.81,1.16-.42.78-.62,1.9-.62,3.37s.21,2.6.62,3.4c.43.79,1.03,1.19,1.81,1.19s1.37-.4,1.78-1.19c.41-.79.62-1.92.62-3.4s-.21-2.59-.62-3.37c-.42-.77-1.01-1.16-1.78-1.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m638.15,457.79c1.51,0,2.66.56,3.45,1.67.79,1.1,1.19,2.66,1.19,4.7s-.4,3.64-1.19,4.75c-.79,1.1-1.95,1.64-3.45,1.64s-2.65-.54-3.45-1.64c-.79-1.11-1.19-2.7-1.19-4.75s.4-3.6,1.19-4.7c.81-1.11,1.96-1.67,3.45-1.67Zm0,1.84c-.78,0-1.38.39-1.81,1.16-.42.78-.62,1.9-.62,3.37s.21,2.6.62,3.4c.43.79,1.03,1.19,1.81,1.19s1.37-.4,1.78-1.19c.41-.79.62-1.92.62-3.4s-.21-2.59-.62-3.37c-.42-.77-1.01-1.16-1.78-1.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m648.01,470.56c-1.13,0-2.05-.31-2.75-.93-.7-.62-1.09-1.49-1.16-2.6h2.18c.07.59.27,1.02.59,1.3.32.28.74.42,1.25.42.79,0,1.42-.34,1.9-1.02.49-.68.75-1.71.79-3.11h-.06c-.74.95-1.7,1.42-2.89,1.42-.78,0-1.46-.17-2.07-.51-.59-.34-1.05-.81-1.39-1.42-.33-.6-.48-1.29-.48-2.07,0-.83.18-1.56.54-2.21.38-.64.89-1.14,1.56-1.5.68-.35,1.44-.54,2.29-.54,1.45,0,2.56.5,3.34,1.5.77,1,1.16,2.49,1.16,4.47,0,2.17-.42,3.85-1.27,5.04-.83,1.17-2.01,1.75-3.54,1.75Zm.28-6.2c.64,0,1.16-.23,1.56-.68s.59-1.03.59-1.73-.19-1.29-.57-1.73c-.38-.43-.9-.65-1.56-.65s-1.19.22-1.58.65c-.38.44-.57,1.02-.57,1.75s.18,1.29.57,1.73c.38.44.89.65,1.56.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m654.46,465.83v-1.7h4.53v1.7h-4.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m664.18,470.28v-8.58h-2.83v-1.56c.98,0,1.71-.16,2.18-.48.49-.32.79-.85.91-1.58h1.9v12.2h-2.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m675.29,457.79c1.28,0,2.29.31,3.03.93.75.61,1.13,1.43,1.13,2.46,0,.7-.17,1.27-.51,1.73-.34.44-.88.79-1.61,1.05v.06c.81.27,1.39.64,1.75,1.13.38.47.57,1.1.57,1.87,0,.72-.18,1.34-.54,1.87-.36.53-.87.95-1.53,1.25-.67.28-1.42.42-2.26.42-1.44,0-2.54-.35-3.31-1.08-.78-.71-1.16-1.73-1.16-3.06h2.15c0,.78.18,1.36.57,1.75.4.38.98.57,1.75.57.64,0,1.16-.16,1.56-.48.4-.34.59-.78.59-1.33,0-1.28-.89-1.92-2.66-1.92h-.45v-1.75h.45c.77,0,1.39-.17,1.84-.51s.68-.79.68-1.36c0-.52-.2-.96-.59-1.3-.38-.34-.89-.51-1.53-.51s-1.18.19-1.56.57c-.36.36-.54.91-.54,1.64h-2.15c0-1.25.38-2.21,1.13-2.92.77-.71,1.84-1.08,3.2-1.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m741.84,457.79c.81,0,1.51.14,2.12.42.62.28,1.1.69,1.44,1.22.34.51.51,1.12.51,1.81s-.13,1.27-.4,1.78c-.25.5-.59.93-1.05,1.3-.45.36-1.05.75-1.78,1.16-.78.45-1.36.84-1.75,1.16-.4.33-.67.62-.82.91-.16.28-.24.59-.25.93h6.34v1.78h-8.8v-.37c0-.85.09-1.56.28-2.15.18-.58.54-1.14,1.05-1.67.51-.54,1.25-1.09,2.21-1.64.69-.4,1.22-.74,1.58-1.02.38-.28.67-.58.88-.91.21-.34.31-.74.31-1.19,0-.52-.17-.94-.51-1.25-.34-.32-.79-.48-1.36-.48-1.36,0-2.07.72-2.12,2.15h-2.15c.01-1.26.4-2.24,1.16-2.92.75-.69,1.79-1.05,3.11-1.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m752.36,457.79c1.51,0,2.66.56,3.45,1.67.79,1.1,1.19,2.66,1.19,4.7s-.4,3.64-1.19,4.75c-.79,1.1-1.95,1.64-3.45,1.64s-2.65-.54-3.45-1.64c-.79-1.11-1.19-2.7-1.19-4.75s.4-3.6,1.19-4.7c.81-1.11,1.96-1.67,3.45-1.67Zm0,1.84c-.78,0-1.38.39-1.81,1.16-.42.78-.62,1.9-.62,3.37s.21,2.6.62,3.4c.43.79,1.03,1.19,1.81,1.19s1.37-.4,1.78-1.19c.41-.79.62-1.92.62-3.4s-.21-2.59-.62-3.37c-.42-.77-1.01-1.16-1.78-1.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m762.25,470.28v-8.58h-2.83v-1.56c.98,0,1.71-.16,2.18-.48.49-.32.79-.85.91-1.58h1.9v12.2h-2.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m776.4,467.33v2.94h-2.15v-2.94h-5.8v-1.84l5.09-7.42h2.86v7.56h1.87v1.7h-1.87Zm-2.09-1.7v-1.58c0-1.26.03-2.7.08-4.3h-.03c-.59.96-1.46,2.31-2.63,4.02l-1.27,1.87h3.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m779.19,465.83v-1.7h4.53v1.7h-4.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m788.91,470.28v-8.58h-2.83v-1.56c.98,0,1.71-.16,2.18-.48.49-.32.79-.85.91-1.58h1.9v12.2h-2.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m800.05,457.79c.81,0,1.54.14,2.18.42.64.27,1.14.65,1.5,1.16.35.51.54,1.1.54,1.75s-.2,1.27-.59,1.75c-.38.47-.91.81-1.58,1.02v.06c.75.21,1.34.58,1.78,1.1.43.53.65,1.17.65,1.92s-.19,1.35-.57,1.9c-.36.53-.88.95-1.56,1.25-.68.28-1.46.42-2.35.42s-1.67-.14-2.35-.42c-.67-.3-1.18-.71-1.56-1.25-.38-.54-.57-1.17-.57-1.9s.21-1.39.65-1.92c.43-.52,1.03-.89,1.78-1.1v-.06c-.68-.21-1.22-.54-1.61-1.02-.38-.49-.57-1.08-.57-1.75s.18-1.25.54-1.75c.38-.51.88-.89,1.5-1.16.64-.28,1.37-.42,2.18-.42Zm0,1.78c-.64,0-1.16.16-1.56.48-.38.3-.57.72-.57,1.25,0,.57.18,1.01.57,1.33.38.33.89.48,1.56.48s1.17-.16,1.56-.48c.38-.32.57-.76.57-1.33,0-.52-.2-.94-.59-1.25-.38-.32-.89-.48-1.53-.48Zm0,5.29c-.68,0-1.24.18-1.67.54-.42.34-.62.81-.62,1.39s.2,1.06.59,1.42c.41.36.98.54,1.7.54s1.25-.18,1.67-.54c.43-.35.65-.83.65-1.42s-.22-1.03-.65-1.39c-.42-.35-.98-.54-1.67-.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m866.57,457.79c.81,0,1.51.14,2.12.42.62.28,1.1.69,1.44,1.22.34.51.51,1.12.51,1.81s-.13,1.27-.4,1.78c-.25.5-.59.93-1.05,1.3-.45.36-1.05.75-1.78,1.16-.78.45-1.36.84-1.75,1.16-.4.33-.67.62-.82.91-.16.28-.24.59-.25.93h6.34v1.78h-8.8v-.37c0-.85.09-1.56.28-2.15.18-.58.54-1.14,1.05-1.67.51-.54,1.25-1.09,2.21-1.64.69-.4,1.22-.74,1.58-1.02.38-.28.67-.58.88-.91.21-.34.31-.74.31-1.19,0-.52-.17-.94-.51-1.25-.34-.32-.79-.48-1.36-.48-1.36,0-2.07.72-2.12,2.15h-2.15c.01-1.26.4-2.24,1.16-2.92.75-.69,1.79-1.05,3.11-1.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m877.09,457.79c1.51,0,2.66.56,3.45,1.67.79,1.1,1.19,2.66,1.19,4.7s-.4,3.64-1.19,4.75c-.79,1.1-1.95,1.64-3.45,1.64s-2.65-.54-3.45-1.64c-.79-1.11-1.19-2.7-1.19-4.75s.4-3.6,1.19-4.7c.81-1.11,1.96-1.67,3.45-1.67Zm0,1.84c-.78,0-1.38.39-1.81,1.16-.42.78-.62,1.9-.62,3.37s.21,2.6.62,3.4c.43.79,1.03,1.19,1.81,1.19s1.37-.4,1.78-1.19c.41-.79.62-1.92.62-3.4s-.21-2.59-.62-3.37c-.42-.77-1.01-1.16-1.78-1.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m886.99,470.28v-8.58h-2.83v-1.56c.98,0,1.71-.16,2.18-.48.49-.32.79-.85.91-1.58h1.9v12.2h-2.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m897.48,470.56c-1.13,0-2.05-.31-2.75-.93-.7-.62-1.09-1.49-1.16-2.6h2.18c.07.59.27,1.02.59,1.3.32.28.74.42,1.25.42.79,0,1.42-.34,1.9-1.02.49-.68.75-1.71.79-3.11h-.06c-.74.95-1.7,1.42-2.89,1.42-.78,0-1.46-.17-2.07-.51-.59-.34-1.05-.81-1.39-1.42-.33-.6-.48-1.29-.48-2.07,0-.83.18-1.56.54-2.21.38-.64.89-1.14,1.56-1.5.68-.35,1.44-.54,2.29-.54,1.45,0,2.56.5,3.34,1.5.77,1,1.16,2.49,1.16,4.47,0,2.17-.42,3.85-1.27,5.04-.83,1.17-2.01,1.75-3.54,1.75Zm.28-6.2c.64,0,1.16-.23,1.56-.68s.59-1.03.59-1.73-.19-1.29-.57-1.73c-.38-.43-.9-.65-1.56-.65s-1.19.22-1.58.65c-.38.44-.57,1.02-.57,1.75s.18,1.29.57,1.73c.38.44.89.65,1.56.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m903.92,465.83v-1.7h4.53v1.7h-4.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m914.26,457.79c.81,0,1.51.14,2.12.42.62.28,1.1.69,1.44,1.22.34.51.51,1.12.51,1.81s-.13,1.27-.4,1.78c-.25.5-.59.93-1.05,1.3-.45.36-1.05.75-1.78,1.16-.78.45-1.36.84-1.75,1.16-.4.33-.67.62-.82.91-.16.28-.24.59-.25.93h6.34v1.78h-8.8v-.37c0-.85.09-1.56.28-2.15.18-.58.54-1.14,1.05-1.67.51-.54,1.25-1.09,2.21-1.64.69-.4,1.22-.74,1.58-1.02.38-.28.67-.58.88-.91.21-.34.31-.74.31-1.19,0-.52-.17-.94-.51-1.25-.34-.32-.79-.48-1.36-.48-1.36,0-2.07.72-2.12,2.15h-2.15c.01-1.26.4-2.24,1.16-2.92.75-.69,1.79-1.05,3.11-1.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m924.75,457.79c1.28,0,2.29.31,3.03.93.75.61,1.13,1.43,1.13,2.46,0,.7-.17,1.27-.51,1.73-.34.44-.88.79-1.61,1.05v.06c.81.27,1.39.64,1.75,1.13.38.47.57,1.1.57,1.87,0,.72-.18,1.34-.54,1.87-.36.53-.87.95-1.53,1.25-.67.28-1.42.42-2.26.42-1.44,0-2.54-.35-3.31-1.08-.78-.71-1.16-1.73-1.16-3.06h2.15c0,.78.18,1.36.57,1.75.4.38.98.57,1.75.57.64,0,1.16-.16,1.56-.48.4-.34.59-.78.59-1.33,0-1.28-.89-1.92-2.66-1.92h-.45v-1.75h.45c.77,0,1.39-.17,1.84-.51s.68-.79.68-1.36c0-.52-.2-.96-.59-1.3-.38-.34-.89-.51-1.53-.51s-1.18.19-1.56.57c-.36.36-.54.91-.54,1.64h-2.15c0-1.25.38-2.21,1.13-2.92.77-.71,1.84-1.08,3.2-1.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 90.31,
    y: 201.06,
    width: 862.34,
    height: 1.36,
    style: {
      fill: "#444"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-4)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      mask: "url(#mask)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 90.2,
    y: 200.02,
    width: 864.04,
    height: 3.62,
    style: {
      fill: "#444"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-5)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 90.31,
    y: 201.06,
    width: 862.34,
    height: 1.36,
    style: {
      fill: "#444"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-6)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90.31,201.06h862.68v244.54H90.31v-244.54Z",
    style: {
      fill: "#444"
    }
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 90.31,
    y: 249.79,
    width: 862.34,
    height: 1.36,
    style: {
      fill: "#444"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-7)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      mask: "url(#mask-1)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 90.2,
    y: 248.93,
    width: 864.04,
    height: 3.62,
    style: {
      fill: "#444"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-8)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 90.31,
    y: 249.79,
    width: 862.34,
    height: 1.36,
    style: {
      fill: "#444"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-9)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90.31,201.06h862.68v244.54H90.31v-244.54Z",
    style: {
      fill: "#444"
    }
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 90.31,
    y: 298.52,
    width: 862.34,
    height: 1.36,
    style: {
      fill: "#444"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-10)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      mask: "url(#mask-2)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 90.2,
    y: 297.84,
    width: 864.04,
    height: 3.62,
    style: {
      fill: "#444"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-11)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 90.31,
    y: 298.52,
    width: 862.34,
    height: 1.36,
    style: {
      fill: "#444"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-12)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90.31,201.06h862.68v244.54H90.31v-244.54Z",
    style: {
      fill: "#444"
    }
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 90.31,
    y: 347.24,
    width: 862.34,
    height: 1.36,
    style: {
      fill: "#444"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-13)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      mask: "url(#mask-3)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 90.2,
    y: 346.75,
    width: 864.04,
    height: 3.62,
    style: {
      fill: "#444"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-14)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 90.31,
    y: 347.24,
    width: 862.34,
    height: 1.36,
    style: {
      fill: "#444"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-15)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90.31,201.06h862.68v244.54H90.31v-244.54Z",
    style: {
      fill: "#444"
    }
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 90.31,
    y: 395.97,
    width: 862.34,
    height: 1.36,
    style: {
      fill: "#444"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-16)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      mask: "url(#mask-4)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 90.2,
    y: 395.65,
    width: 864.04,
    height: 1.81,
    style: {
      fill: "#444"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-17)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 90.31,
    y: 395.97,
    width: 862.34,
    height: 1.36,
    style: {
      fill: "#444"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-18)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90.31,201.06h862.68v244.54H90.31v-244.54Z",
    style: {
      fill: "#444"
    }
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 90.31,
    y: 444.69,
    width: 862.34,
    height: 1.36,
    style: {
      fill: "#444"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-19)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      mask: "url(#mask-5)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 90.2,
    y: 444.56,
    width: 864.04,
    height: 1.81,
    style: {
      fill: "#444"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-20)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 90.31,
    y: 444.69,
    width: 862.34,
    height: 1.36,
    style: {
      fill: "#444"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-21)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90.31,201.06h862.68v244.54H90.31v-244.54Z",
    style: {
      fill: "#444"
    }
  })))))))), /*#__PURE__*/React.createElement("path", {
    d: "m50.18,207.18v-8.58h-2.83v-1.56c.98,0,1.71-.16,2.18-.48.49-.32.79-.85.91-1.58h1.9v12.2h-2.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.32,194.7c.81,0,1.51.14,2.12.42.62.28,1.1.69,1.44,1.22.34.51.51,1.12.51,1.81s-.13,1.27-.4,1.78c-.25.5-.59.93-1.05,1.3-.45.36-1.05.75-1.78,1.16-.78.45-1.36.84-1.75,1.16-.4.33-.67.62-.82.91-.16.28-.24.59-.25.93h6.34v1.78h-8.8v-.37c0-.85.09-1.56.28-2.15.18-.58.54-1.14,1.05-1.67.51-.54,1.25-1.09,2.21-1.64.69-.4,1.22-.74,1.58-1.02.38-.28.67-.58.88-.91.21-.34.31-.74.31-1.19,0-.52-.17-.94-.51-1.25-.34-.32-.79-.48-1.36-.48-1.36,0-2.07.72-2.12,2.15h-2.15c.01-1.26.4-2.24,1.16-2.92.75-.69,1.79-1.05,3.11-1.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.03,196.74l-.34,3.31h.03c.3-.3.66-.52,1.08-.68.43-.17.88-.25,1.36-.25.79,0,1.49.17,2.09.51.62.33,1.09.79,1.42,1.42.34.61.51,1.3.51,2.09,0,.87-.19,1.63-.57,2.29-.36.64-.88,1.15-1.56,1.5-.68.35-1.47.54-2.38.54-1.27,0-2.28-.32-3.03-.96-.76-.64-1.13-1.51-1.13-2.6h2.15c.01.55.21.98.59,1.3.38.3.85.45,1.42.45.71,0,1.27-.21,1.67-.62.4-.43.59-1.03.59-1.81s-.2-1.34-.59-1.75c-.38-.41-.91-.62-1.58-.62-.53,0-.98.13-1.33.4-.34.27-.58.64-.71,1.1l-2.12-.14.71-7.22h7.27v1.75h-5.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.18,255.9v-8.58h-2.83v-1.56c.98,0,1.71-.16,2.18-.48.49-.32.79-.85.91-1.58h1.9v12.2h-2.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.32,243.42c1.51,0,2.66.56,3.45,1.67.79,1.1,1.19,2.66,1.19,4.7s-.4,3.64-1.19,4.75c-.79,1.1-1.95,1.64-3.45,1.64s-2.65-.54-3.45-1.64c-.79-1.11-1.19-2.7-1.19-4.75s.4-3.6,1.19-4.7c.81-1.11,1.96-1.67,3.45-1.67Zm0,1.84c-.78,0-1.38.39-1.81,1.16-.42.78-.62,1.9-.62,3.37s.21,2.6.62,3.4c.43.79,1.03,1.19,1.81,1.19s1.37-.4,1.78-1.19c.41-.79.62-1.92.62-3.4s-.21-2.59-.62-3.37c-.42-.77-1.01-1.16-1.78-1.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.84,243.42c1.51,0,2.66.56,3.45,1.67.79,1.1,1.19,2.66,1.19,4.7s-.4,3.64-1.19,4.75c-.79,1.1-1.95,1.64-3.45,1.64s-2.65-.54-3.45-1.64c-.79-1.11-1.19-2.7-1.19-4.75s.4-3.6,1.19-4.7c.81-1.11,1.96-1.67,3.45-1.67Zm0,1.84c-.78,0-1.38.39-1.81,1.16-.42.78-.62,1.9-.62,3.37s.21,2.6.62,3.4c.43.79,1.03,1.19,1.81,1.19s1.37-.4,1.78-1.19c.41-.79.62-1.92.62-3.4s-.21-2.59-.62-3.37c-.42-.77-1.01-1.16-1.78-1.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.62,294.3c-.95,1.34-1.78,2.9-2.52,4.67-.72,1.78-1.26,3.67-1.61,5.66h-2.35c.47-2.19,1.09-4.17,1.87-5.94.79-1.79,1.62-3.27,2.49-4.44h-6.65v-1.81h8.77v1.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.03,294.18l-.34,3.31h.03c.3-.3.66-.52,1.08-.68.43-.17.88-.25,1.36-.25.79,0,1.49.17,2.09.51.62.33,1.09.79,1.42,1.42.34.61.51,1.3.51,2.09,0,.87-.19,1.63-.57,2.29-.36.64-.88,1.15-1.56,1.5-.68.35-1.47.54-2.38.54-1.27,0-2.28-.32-3.03-.96-.76-.64-1.13-1.51-1.13-2.6h2.15c.01.55.21.98.59,1.3.38.3.85.45,1.42.45.71,0,1.27-.21,1.67-.62.4-.43.59-1.03.59-1.81s-.2-1.34-.59-1.75c-.38-.41-.91-.62-1.58-.62-.53,0-.98.13-1.33.4-.34.27-.58.64-.71,1.1l-2.12-.14.71-7.22h7.27v1.75h-5.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.51,342.91l-.34,3.31h.03c.3-.3.66-.52,1.08-.68.43-.17.88-.25,1.36-.25.79,0,1.49.17,2.09.51.62.33,1.09.79,1.42,1.42.34.61.51,1.3.51,2.09,0,.87-.19,1.63-.57,2.29-.36.64-.88,1.15-1.56,1.5-.68.35-1.47.54-2.38.54-1.27,0-2.28-.32-3.03-.96-.76-.64-1.13-1.51-1.13-2.6h2.15c.01.55.21.98.59,1.3.38.3.85.45,1.42.45.71,0,1.27-.21,1.67-.62.4-.43.59-1.03.59-1.81s-.2-1.34-.59-1.75c-.38-.41-.91-.62-1.58-.62-.53,0-.98.13-1.33.4-.34.27-.58.64-.71,1.1l-2.12-.14.71-7.22h7.27v1.75h-5.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.84,340.87c1.51,0,2.66.56,3.45,1.67.79,1.1,1.19,2.66,1.19,4.7s-.4,3.64-1.19,4.75c-.79,1.1-1.95,1.64-3.45,1.64s-2.65-.54-3.45-1.64c-.79-1.11-1.19-2.7-1.19-4.75s.4-3.6,1.19-4.7c.81-1.11,1.96-1.67,3.45-1.67Zm0,1.84c-.78,0-1.38.39-1.81,1.16-.42.78-.62,1.9-.62,3.37s.21,2.6.62,3.4c.43.79,1.03,1.19,1.81,1.19s1.37-.4,1.78-1.19c.41-.79.62-1.92.62-3.4s-.21-2.59-.62-3.37c-.42-.77-1.01-1.16-1.78-1.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.32,389.6c.81,0,1.51.14,2.12.42.62.28,1.1.69,1.44,1.22.34.51.51,1.12.51,1.81s-.13,1.27-.4,1.78c-.25.5-.59.93-1.05,1.3-.45.36-1.05.75-1.78,1.16-.78.45-1.36.84-1.75,1.16-.4.33-.67.62-.82.91-.16.28-.24.59-.25.93h6.34v1.78h-8.8v-.37c0-.85.09-1.56.28-2.15.18-.58.54-1.14,1.05-1.67.51-.54,1.25-1.09,2.21-1.64.69-.4,1.22-.74,1.58-1.02.38-.28.67-.58.88-.91.21-.34.31-.74.31-1.19,0-.52-.17-.94-.51-1.25-.34-.32-.79-.48-1.36-.48-1.36,0-2.07.72-2.12,2.15h-2.15c.01-1.26.4-2.24,1.16-2.92.75-.69,1.79-1.05,3.11-1.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.03,391.63l-.34,3.31h.03c.3-.3.66-.52,1.08-.68.43-.17.88-.25,1.36-.25.79,0,1.49.17,2.09.51.62.33,1.09.79,1.42,1.42.34.61.51,1.3.51,2.09,0,.87-.19,1.63-.57,2.29-.36.64-.88,1.15-1.56,1.5-.68.35-1.47.54-2.38.54-1.27,0-2.28-.32-3.03-.96-.76-.64-1.13-1.51-1.13-2.6h2.15c.01.55.21.98.59,1.3.38.3.85.45,1.42.45.71,0,1.27-.21,1.67-.62.4-.43.59-1.03.59-1.81s-.2-1.34-.59-1.75c-.38-.41-.91-.62-1.58-.62-.53,0-.98.13-1.33.4-.34.27-.58.64-.71,1.1l-2.12-.14.71-7.22h7.27v1.75h-5.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.84,438.32c1.51,0,2.66.56,3.45,1.67.79,1.1,1.19,2.66,1.19,4.7s-.4,3.64-1.19,4.75c-.79,1.1-1.95,1.64-3.45,1.64s-2.65-.54-3.45-1.64c-.79-1.11-1.19-2.7-1.19-4.75s.4-3.6,1.19-4.7c.81-1.11,1.96-1.67,3.45-1.67Zm0,1.84c-.78,0-1.38.39-1.81,1.16-.42.78-.62,1.9-.62,3.37s.21,2.6.62,3.4c.43.79,1.03,1.19,1.81,1.19s1.37-.4,1.78-1.19c.41-.79.62-1.92.62-3.4s-.21-2.59-.62-3.37c-.42-.77-1.01-1.16-1.78-1.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-22)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90.31,206.91h862.68v239.11H90.31v-239.11Z",
    style: {
      fill: "#ff5722"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-23)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90.31,206.91h862.68v239.11H90.31v-239.11Z",
    style: {
      fill: "#ff5722"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-24)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90.31,206.91h862.68v239.11H90.31v-239.11Z",
    style: {
      fill: "#ff5722"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-25)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90.31,206.91h862.68v239.11H90.31v-239.11Z",
    style: {
      fill: "#ff5722"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-26)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90.31,206.91h862.68v239.11H90.31v-239.11Z",
    style: {
      fill: "#ff5722"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-27)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90.31,206.91h862.68v239.11H90.31v-239.11Z",
    style: {
      fill: "#ff5722"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-28)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90.31,206.91h862.68v239.11H90.31v-239.11Z",
    style: {
      fill: "#ff5722"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-29)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90.31,206.91h862.68v239.11H90.31v-239.11Z",
    style: {
      fill: "#9d22ff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-30)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90.31,206.91h862.68v239.11H90.31v-239.11Z",
    style: {
      fill: "#9d22ff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-31)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90.31,206.91h862.68v239.11H90.31v-239.11Z",
    style: {
      fill: "#9d22ff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-32)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90.31,206.91h862.68v239.11H90.31v-239.11Z",
    style: {
      fill: "#9d22ff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-33)",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90.31,206.91h862.68v239.11H90.31v-239.11Z",
    style: {
      fill: "#9d22ff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m125.35,46.61v18.74h-3.68v-18.74h-7.19v-3.2h18.09v3.2h-7.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m141.74,49.24c1.56,0,2.92.34,4.08,1.02,1.17.68,2.07,1.64,2.69,2.89.62,1.23.93,2.69.93,4.39s-.31,3.14-.93,4.39-1.52,2.21-2.69,2.89c-1.15.66-2.51.99-4.08.99s-2.91-.33-4.08-.99c-1.17-.68-2.08-1.64-2.72-2.89-.62-1.25-.93-2.7-.93-4.39s.31-3.16.93-4.39c.64-1.25,1.54-2.21,2.72-2.89,1.17-.68,2.53-1.02,4.08-1.02Zm0,2.77c-1.25,0-2.23.5-2.94,1.47-.72.98-1.08,2.34-1.08,4.05s.35,3.04,1.08,4.02c.71.98,1.7,1.47,2.94,1.47s2.25-.49,2.97-1.47c.71-.98,1.08-2.32,1.08-4.02s-.36-3.06-1.08-4.05c-.72-.98-1.71-1.47-2.97-1.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159.14,62.66c.45,0,.81-.04,1.08-.14v2.75c-.62.18-1.27.28-1.95.28-1.66,0-2.87-.38-3.62-1.13-.76-.75-1.13-1.98-1.13-3.68v-8.35h-2.6v-2.69h2.6v-3.91h3.51v3.91h3.06v2.69h-3.06v7.81c0,.89.16,1.52.48,1.9.34.38.88.57,1.64.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169.15,49.24c2.09,0,3.69.52,4.78,1.56,1.11,1.02,1.67,2.54,1.67,4.56v5.86c0,1.68.13,3.06.4,4.13h-3.17c-.16-.64-.23-1.37-.23-2.18h-.06c-1.15,1.68-2.91,2.52-5.26,2.52-1.61,0-2.89-.43-3.85-1.3-.96-.88-1.44-2-1.44-3.34s.45-2.41,1.36-3.2c.91-.81,2.45-1.39,4.64-1.73,1.3-.23,2.7-.38,4.22-.48v-.59c0-1.11-.28-1.93-.82-2.46-.55-.52-1.29-.79-2.24-.79s-1.68.25-2.21.76c-.53.5-.82,1.15-.88,1.98h-3.45c.09-1.56.69-2.84,1.81-3.82,1.11-.98,2.69-1.47,4.73-1.47Zm3.06,8.69c-1.34.08-2.54.21-3.59.4-1.13.19-1.94.47-2.41.85-.45.36-.68.9-.68,1.61s.23,1.27.71,1.7c.49.42,1.17.62,2.07.62.54,0,1.06-.08,1.56-.25.49-.18.91-.45,1.27-.79.41-.43.69-.88.85-1.36.15-.49.23-1.16.23-2.01v-.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.88,65.35v-21.93h3.51v21.93h-3.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.26,65.35l-4.73-9.17c-1.66-3.24-3.21-6.38-4.64-9.42h-.08c.13,3.33.2,6.64.2,9.96v8.63h-3.57v-21.93h5.32l4.7,9.2c1.68,3.23,3.23,6.36,4.67,9.4h.06c-.11-3.68-.17-7-.17-9.96v-8.63h3.57v21.93h-5.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224.08,65.71c-1.8,0-3.19-.54-4.19-1.61-1-1.09-1.5-2.7-1.5-4.81v-9.59h3.51v9.28c0,2.6,1.05,3.91,3.17,3.91,1.05,0,1.91-.38,2.58-1.16.66-.79.99-1.9.99-3.34v-8.69h3.51v15.65h-3.31v-2.04h-.06c-.53.74-1.19,1.32-1.98,1.75-.79.43-1.7.65-2.72.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.04,49.33c1.68,0,2.99.55,3.93,1.64.94,1.1,1.42,2.67,1.42,4.73v9.65h-3.51v-9.31c0-2.58-.95-3.88-2.83-3.88-1.02,0-1.83.42-2.41,1.25-.59.83-.88,2-.88,3.51v8.43h-3.51v-9.68c0-1.09-.25-1.95-.74-2.58-.47-.62-1.16-.93-2.07-.93-1.06,0-1.88.42-2.46,1.27-.57.85-.85,2.03-.85,3.54v8.38h-3.51v-15.65h3.37v1.9h.06c.57-.77,1.2-1.34,1.9-1.7.71-.38,1.54-.57,2.46-.57,1.08,0,2.01.25,2.8.74.81.47,1.42,1.17,1.81,2.09.58-.92,1.27-1.62,2.07-2.09.81-.49,1.79-.74,2.94-.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m267.32,51.73c.45-.75,1.08-1.34,1.9-1.78.81-.43,1.71-.65,2.69-.65,1.3,0,2.44.34,3.42,1.02.98.68,1.73,1.64,2.26,2.89.52,1.25.79,2.69.79,4.33s-.27,3.09-.79,4.33c-.53,1.23-1.29,2.18-2.29,2.86-.98.66-2.12.99-3.42.99-1,0-1.92-.22-2.75-.65-.83-.45-1.47-1.08-1.92-1.87h-.06v2.15h-3.42v-21.93h3.51v8.32h.08Zm3.54.31c-1.15,0-2.08.5-2.77,1.47-.68.96-1.02,2.31-1.02,4.02s.34,3.01,1.02,3.99c.69.98,1.62,1.47,2.77,1.47s2.13-.49,2.83-1.47c.69-1,1.05-2.33,1.05-3.99s-.35-2.99-1.05-3.99c-.7-1-1.64-1.5-2.83-1.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288.3,63.22c.98,0,1.78-.23,2.41-.71.64-.47,1.03-1.09,1.19-1.87h3.62c-.33,1.47-1.13,2.7-2.41,3.68-1.27.98-2.87,1.47-4.81,1.47-1.57,0-2.92-.35-4.05-1.05-1.13-.71-2.01-1.71-2.63-2.97-.61-1.28-.91-2.76-.91-4.44,0-1.53.29-2.9.88-4.13.6-1.25,1.47-2.21,2.6-2.92,1.15-.69,2.5-1.05,4.05-1.05,1.75,0,3.25.48,4.5,1.44,1.25.95,2.08,2.24,2.52,3.88.28.93.42,2.15.42,3.68h-11.49c.07,1.68.48,2.94,1.22,3.76.75.81,1.71,1.22,2.89,1.22Zm-.06-11.41c-1.1,0-2,.35-2.72,1.05-.7.7-1.13,1.72-1.27,3.06h7.92c-.11-1.34-.53-2.36-1.25-3.06-.72-.69-1.61-1.05-2.69-1.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m306.9,49.5c.4,0,.82.05,1.27.14v3.11c-.38-.07-.79-.11-1.22-.11-1.4,0-2.48.44-3.23,1.3-.76.87-1.13,2.12-1.13,3.74v7.67h-3.51v-15.65h3.28v2.32h.06c1.03-1.68,2.53-2.52,4.47-2.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m324.42,49.24c1.56,0,2.92.34,4.08,1.02,1.17.68,2.07,1.64,2.69,2.89.62,1.23.93,2.69.93,4.39s-.31,3.14-.93,4.39-1.52,2.21-2.69,2.89c-1.15.66-2.51.99-4.08.99s-2.91-.33-4.08-.99c-1.17-.68-2.08-1.64-2.72-2.89-.62-1.25-.93-2.7-.93-4.39s.31-3.16.93-4.39c.64-1.25,1.54-2.21,2.72-2.89,1.17-.68,2.53-1.02,4.08-1.02Zm0,2.77c-1.25,0-2.23.5-2.94,1.47-.72.98-1.08,2.34-1.08,4.05s.35,3.04,1.08,4.02c.71.98,1.7,1.47,2.94,1.47s2.25-.49,2.97-1.47c.71-.98,1.08-2.32,1.08-4.02s-.36-3.06-1.08-4.05c-.72-.98-1.71-1.47-2.97-1.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m342.04,45.87c-.76,0-1.32.21-1.7.62-.36.4-.54,1.05-.54,1.95v1.25h3v2.69h-3v12.96h-3.48v-12.96h-2.66v-2.69h2.66v-1.64c0-1.6.4-2.81,1.19-3.62.79-.81,1.97-1.22,3.54-1.22.51,0,1.12.07,1.84.2v2.6c-.28-.09-.57-.14-.85-.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m361.38,42.96c1.73,0,3.26.34,4.59,1.02,1.32.68,2.35,1.63,3.09,2.83.74,1.19,1.14,2.57,1.22,4.13h-3.74c-.16-1.45-.69-2.59-1.61-3.42-.91-.85-2.09-1.27-3.54-1.27-1.87,0-3.34.73-4.42,2.18-1.08,1.46-1.61,3.45-1.61,5.97s.52,4.49,1.58,5.94c1.05,1.46,2.5,2.18,4.33,2.18,1.47,0,2.67-.41,3.59-1.25.94-.85,1.51-2.02,1.7-3.54h3.79c-.23,2.53-1.15,4.51-2.75,5.94-1.58,1.42-3.7,2.12-6.34,2.12-1.98,0-3.71-.46-5.18-1.39-1.47-.92-2.6-2.24-3.37-3.93-.78-1.71-1.16-3.74-1.16-6.09s.38-4.37,1.16-6.09c.79-1.71,1.92-3.04,3.4-3.96,1.49-.92,3.24-1.39,5.26-1.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m373.94,65.35v-21.93h3.51v21.93h-3.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m387.8,49.24c2.09,0,3.69.52,4.78,1.56,1.11,1.02,1.67,2.54,1.67,4.56v5.86c0,1.68.13,3.06.4,4.13h-3.17c-.16-.64-.23-1.37-.23-2.18h-.06c-1.15,1.68-2.91,2.52-5.26,2.52-1.61,0-2.89-.43-3.85-1.3-.96-.88-1.44-2-1.44-3.34s.45-2.41,1.36-3.2c.91-.81,2.45-1.39,4.64-1.73,1.3-.23,2.7-.38,4.22-.48v-.59c0-1.11-.28-1.93-.82-2.46-.55-.52-1.29-.79-2.24-.79s-1.68.25-2.21.76c-.53.5-.82,1.15-.88,1.98h-3.45c.09-1.56.69-2.84,1.81-3.82,1.11-.98,2.69-1.47,4.73-1.47Zm3.06,8.69c-1.34.08-2.54.21-3.59.4-1.13.19-1.94.47-2.41.85-.45.36-.68.9-.68,1.61s.23,1.27.71,1.7c.49.42,1.17.62,2.07.62.54,0,1.06-.08,1.56-.25.49-.18.91-.45,1.27-.79.41-.43.69-.88.85-1.36.15-.49.23-1.16.23-2.01v-.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m398.54,65.35v-15.65h3.51v15.65h-3.51Zm0-18.57v-3.37h3.51v3.37h-3.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.95,49.33c1.68,0,2.99.55,3.93,1.64.94,1.1,1.42,2.67,1.42,4.73v9.65h-3.51v-9.31c0-2.58-.95-3.88-2.83-3.88-1.02,0-1.83.42-2.41,1.25-.59.83-.88,2-.88,3.51v8.43h-3.51v-9.68c0-1.09-.25-1.95-.74-2.58-.47-.62-1.16-.93-2.07-.93-1.06,0-1.88.42-2.46,1.27-.57.85-.85,2.03-.85,3.54v8.38h-3.51v-15.65h3.37v1.9h.06c.57-.77,1.2-1.34,1.9-1.7.71-.38,1.54-.57,2.46-.57,1.08,0,2.01.25,2.8.74.81.47,1.42,1.17,1.81,2.09.58-.92,1.27-1.62,2.07-2.09.81-.49,1.79-.74,2.94-.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m439.03,49.24c2,0,3.54.47,4.64,1.39,1.11.91,1.68,2.22,1.7,3.93h-3.4c0-.92-.25-1.61-.76-2.07-.51-.47-1.25-.71-2.21-.71-.83,0-1.47.17-1.92.51-.45.33-.68.78-.68,1.36,0,.42.11.76.34,1.02.24.27.59.47,1.05.62.45.16,1.17.35,2.15.59,1.36.34,2.41.67,3.17.96.75.3,1.39.79,1.92,1.47.54.67.82,1.57.82,2.72,0,1.44-.59,2.59-1.78,3.45-1.19.86-2.77,1.3-4.75,1.3-2.15,0-3.82-.47-5.01-1.42-1.17-.96-1.77-2.36-1.78-4.19h3.57c0,.96.28,1.71.85,2.24.57.51,1.37.76,2.43.76.88,0,1.57-.17,2.07-.51.51-.35.76-.83.76-1.44,0-.51-.13-.91-.4-1.19-.27-.3-.65-.54-1.16-.71-.51-.18-1.3-.41-2.38-.68-1.23-.3-2.18-.58-2.86-.85-.68-.28-1.27-.72-1.78-1.33-.5-.62-.74-1.48-.74-2.58,0-.92.25-1.73.76-2.43.52-.71,1.25-1.26,2.18-1.64.92-.4,1.99-.59,3.2-.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m460.53,46.61v6.76h9.76v3.17h-9.76v8.8h-3.68v-21.93h14.18v3.2h-10.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m474.19,65.35v-15.65h3.51v15.65h-3.51Zm0-18.57v-3.37h3.51v3.37h-3.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m482.2,65.35v-21.93h3.51v21.93h-3.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496.71,63.22c.98,0,1.78-.23,2.41-.71.64-.47,1.03-1.09,1.19-1.87h3.62c-.33,1.47-1.13,2.7-2.41,3.68-1.27.98-2.87,1.47-4.81,1.47-1.57,0-2.92-.35-4.05-1.05-1.13-.71-2.01-1.71-2.63-2.97-.61-1.28-.91-2.76-.91-4.44,0-1.53.29-2.9.88-4.13.6-1.25,1.47-2.21,2.6-2.92,1.15-.69,2.5-1.05,4.05-1.05,1.75,0,3.25.48,4.5,1.44,1.25.95,2.08,2.24,2.52,3.88.28.93.42,2.15.42,3.68h-11.49c.07,1.68.48,2.94,1.22,3.76.75.81,1.71,1.22,2.89,1.22Zm-.06-11.41c-1.1,0-2,.35-2.72,1.05-.7.7-1.13,1.72-1.27,3.06h7.92c-.11-1.34-.53-2.36-1.25-3.06-.72-.69-1.61-1.05-2.69-1.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m517.66,65.35v-2.15h-.06c-.45.79-1.1,1.42-1.92,1.87-.83.43-1.74.65-2.72.65-1.32,0-2.48-.33-3.45-.99-.98-.68-1.75-1.63-2.29-2.86-.53-1.25-.79-2.69-.79-4.33s.26-3.09.79-4.33c.54-1.25,1.3-2.21,2.26-2.89.98-.68,2.13-1.02,3.45-1.02.98,0,1.88.22,2.69.65.81.44,1.44,1.03,1.9,1.78h.06v-8.32h3.51v21.93h-3.42Zm-3.68-13.3c-1.19,0-2.14.5-2.83,1.5-.7,1-1.05,2.34-1.05,3.99s.35,2.99,1.05,3.99c.69.98,1.64,1.47,2.83,1.47s2.07-.49,2.75-1.47c.69-.98,1.05-2.31,1.05-3.99s-.35-3.06-1.05-4.02c-.68-.98-1.6-1.47-2.75-1.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m532.64,65.35v-15.65h3.51v15.65h-3.51Zm0-18.57v-3.37h3.51v3.37h-3.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m548.71,49.33c1.81,0,3.21.55,4.22,1.64,1,1.1,1.5,2.7,1.5,4.81v9.57h-3.51v-9.26c0-2.62-1.06-3.93-3.17-3.93-1.06,0-1.92.4-2.6,1.19-.67.78-.99,1.88-.99,3.31v8.69h-3.51v-15.65h3.34v2.04h.06c.51-.74,1.16-1.32,1.95-1.75.81-.43,1.71-.65,2.72-.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m566.31,65.35v-21.93h3.68v21.93h-3.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m580.34,49.24c2,0,3.54.47,4.64,1.39,1.11.91,1.68,2.22,1.7,3.93h-3.4c0-.92-.25-1.61-.76-2.07-.51-.47-1.25-.71-2.21-.71-.83,0-1.47.17-1.92.51-.45.33-.68.78-.68,1.36,0,.42.11.76.34,1.02.24.27.59.47,1.05.62.45.16,1.17.35,2.15.59,1.36.34,2.41.67,3.17.96.75.3,1.39.79,1.92,1.47.54.67.82,1.57.82,2.72,0,1.44-.59,2.59-1.78,3.45-1.19.86-2.77,1.3-4.75,1.3-2.15,0-3.82-.47-5.01-1.42-1.17-.96-1.77-2.36-1.78-4.19h3.57c0,.96.28,1.71.85,2.24.57.51,1.37.76,2.43.76.88,0,1.57-.17,2.07-.51.51-.35.76-.83.76-1.44,0-.51-.13-.91-.4-1.19-.27-.3-.65-.54-1.16-.71-.51-.18-1.3-.41-2.38-.68-1.23-.3-2.18-.58-2.86-.85-.68-.28-1.27-.72-1.78-1.33-.5-.62-.74-1.48-.74-2.58,0-.92.25-1.73.76-2.43.52-.71,1.25-1.26,2.18-1.64.92-.4,1.99-.59,3.2-.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m598.41,49.5c.4,0,.82.05,1.27.14v3.11c-.38-.07-.79-.11-1.22-.11-1.4,0-2.48.44-3.23,1.3-.76.87-1.13,2.12-1.13,3.74v7.67h-3.51v-15.65h3.28v2.32h.06c1.03-1.68,2.53-2.52,4.47-2.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m608.06,49.24c2.09,0,3.69.52,4.78,1.56,1.11,1.02,1.67,2.54,1.67,4.56v5.86c0,1.68.13,3.06.4,4.13h-3.17c-.16-.64-.23-1.37-.23-2.18h-.06c-1.15,1.68-2.91,2.52-5.26,2.52-1.61,0-2.89-.43-3.85-1.3-.96-.88-1.44-2-1.44-3.34s.45-2.41,1.36-3.2c.91-.81,2.45-1.39,4.64-1.73,1.3-.23,2.7-.38,4.22-.48v-.59c0-1.11-.28-1.93-.82-2.46-.55-.52-1.29-.79-2.24-.79s-1.68.25-2.21.76c-.53.5-.82,1.15-.88,1.98h-3.45c.09-1.56.69-2.84,1.81-3.82,1.11-.98,2.69-1.47,4.73-1.47Zm3.06,8.69c-1.34.08-2.54.21-3.59.4-1.13.19-1.94.47-2.41.85-.45.36-.68.9-.68,1.61s.23,1.27.71,1.7c.49.42,1.17.62,2.07.62.54,0,1.06-.08,1.56-.25.49-.18.91-.45,1.27-.79.41-.43.69-.88.85-1.36.15-.49.23-1.16.23-2.01v-.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m625.31,63.22c.98,0,1.78-.23,2.41-.71.64-.47,1.03-1.09,1.19-1.87h3.62c-.33,1.47-1.13,2.7-2.41,3.68-1.27.98-2.87,1.47-4.81,1.47-1.57,0-2.92-.35-4.05-1.05-1.13-.71-2.01-1.71-2.63-2.97-.61-1.28-.91-2.76-.91-4.44,0-1.53.29-2.9.88-4.13.6-1.25,1.47-2.21,2.6-2.92,1.15-.69,2.5-1.05,4.05-1.05,1.75,0,3.25.48,4.5,1.44,1.25.95,2.08,2.24,2.52,3.88.28.93.42,2.15.42,3.68h-11.49c.07,1.68.48,2.94,1.22,3.76.75.81,1.71,1.22,2.89,1.22Zm-.06-11.41c-1.1,0-2,.35-2.72,1.05-.7.7-1.13,1.72-1.27,3.06h7.92c-.11-1.34-.53-2.36-1.25-3.06-.72-.69-1.61-1.05-2.69-1.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m636.09,65.35v-21.93h3.51v21.93h-3.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m644.1,65.35v-15.65h3.51v15.65h-3.51Zm0-18.57v-3.37h3.51v3.37h-3.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m668.01,42.96c1.73,0,3.26.34,4.59,1.02,1.32.68,2.35,1.63,3.09,2.83.74,1.19,1.14,2.57,1.22,4.13h-3.74c-.16-1.45-.69-2.59-1.61-3.42-.91-.85-2.09-1.27-3.54-1.27-1.87,0-3.34.73-4.42,2.18-1.08,1.46-1.61,3.45-1.61,5.97s.52,4.49,1.58,5.94c1.05,1.46,2.5,2.18,4.33,2.18,1.47,0,2.67-.41,3.59-1.25.94-.85,1.51-2.02,1.7-3.54h3.79c-.23,2.53-1.15,4.51-2.75,5.94-1.58,1.42-3.7,2.12-6.34,2.12-1.98,0-3.71-.46-5.18-1.39-1.47-.92-2.6-2.24-3.37-3.93-.78-1.71-1.16-3.74-1.16-6.09s.38-4.37,1.16-6.09c.79-1.71,1.92-3.04,3.4-3.96,1.49-.92,3.24-1.39,5.26-1.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m680.57,65.35v-15.65h3.51v15.65h-3.51Zm0-18.57v-3.37h3.51v3.37h-3.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m691.6,65.35l-5.46-15.65h3.68l2.04,6.4c.68,2.06,1.34,4.33,1.98,6.82h.08c.64-2.49,1.3-4.76,1.98-6.82l2.04-6.4h3.68l-5.46,15.65h-4.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m703.66,65.35v-15.65h3.51v15.65h-3.51Zm0-18.57v-3.37h3.51v3.37h-3.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m711.66,65.35v-21.93h3.51v21.93h-3.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m719.66,65.35v-15.65h3.51v15.65h-3.51Zm0-18.57v-3.37h3.51v3.37h-3.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m733.52,49.24c2.09,0,3.69.52,4.78,1.56,1.11,1.02,1.67,2.54,1.67,4.56v5.86c0,1.68.13,3.06.4,4.13h-3.17c-.16-.64-.23-1.37-.23-2.18h-.06c-1.15,1.68-2.91,2.52-5.26,2.52-1.61,0-2.89-.43-3.85-1.3-.96-.88-1.44-2-1.44-3.34s.45-2.41,1.36-3.2c.91-.81,2.45-1.39,4.64-1.73,1.3-.23,2.7-.38,4.22-.48v-.59c0-1.11-.28-1.93-.82-2.46-.55-.52-1.29-.79-2.24-.79s-1.68.25-2.21.76c-.53.5-.82,1.15-.88,1.98h-3.45c.09-1.56.69-2.84,1.81-3.82,1.11-.98,2.69-1.47,4.73-1.47Zm3.06,8.69c-1.34.08-2.54.21-3.59.4-1.13.19-1.94.47-2.41.85-.45.36-.68.9-.68,1.61s.23,1.27.71,1.7c.49.42,1.17.62,2.07.62.54,0,1.06-.08,1.56-.25.49-.18.91-.45,1.27-.79.41-.43.69-.88.85-1.36.15-.49.23-1.16.23-2.01v-.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m752.32,49.33c1.81,0,3.21.55,4.22,1.64,1,1.1,1.5,2.7,1.5,4.81v9.57h-3.51v-9.26c0-2.62-1.06-3.93-3.17-3.93-1.06,0-1.92.4-2.6,1.19-.67.78-.99,1.88-.99,3.31v8.69h-3.51v-15.65h3.34v2.04h.06c.51-.74,1.16-1.32,1.95-1.75.81-.43,1.71-.65,2.72-.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m778.26,42.96c1.73,0,3.26.34,4.59,1.02,1.32.68,2.35,1.63,3.09,2.83.74,1.19,1.14,2.57,1.22,4.13h-3.74c-.16-1.45-.69-2.59-1.61-3.42-.91-.85-2.09-1.27-3.54-1.27-1.87,0-3.34.73-4.42,2.18-1.08,1.46-1.61,3.45-1.61,5.97s.52,4.49,1.58,5.94c1.05,1.46,2.5,2.18,4.33,2.18,1.47,0,2.67-.41,3.59-1.25.94-.85,1.51-2.02,1.7-3.54h3.79c-.23,2.53-1.15,4.51-2.75,5.94-1.58,1.42-3.7,2.12-6.34,2.12-1.98,0-3.71-.46-5.18-1.39-1.47-.92-2.6-2.24-3.37-3.93-.78-1.71-1.16-3.74-1.16-6.09s.38-4.37,1.16-6.09c.79-1.71,1.92-3.04,3.4-3.96,1.49-.92,3.24-1.39,5.26-1.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m797.47,49.24c1.56,0,2.92.34,4.08,1.02,1.17.68,2.07,1.64,2.69,2.89.62,1.23.93,2.69.93,4.39s-.31,3.14-.93,4.39-1.52,2.21-2.69,2.89c-1.15.66-2.51.99-4.08.99s-2.91-.33-4.08-.99c-1.17-.68-2.08-1.64-2.72-2.89-.62-1.25-.93-2.7-.93-4.39s.31-3.16.93-4.39c.64-1.25,1.54-2.21,2.72-2.89,1.17-.68,2.53-1.02,4.08-1.02Zm0,2.77c-1.25,0-2.23.5-2.94,1.47-.72.98-1.08,2.34-1.08,4.05s.35,3.04,1.08,4.02c.71.98,1.7,1.47,2.94,1.47s2.25-.49,2.97-1.47c.71-.98,1.08-2.32,1.08-4.02s-.36-3.06-1.08-4.05c-.72-.98-1.71-1.47-2.97-1.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m814.13,65.71c-1.8,0-3.19-.54-4.19-1.61-1-1.09-1.5-2.7-1.5-4.81v-9.59h3.51v9.28c0,2.6,1.05,3.91,3.17,3.91,1.05,0,1.91-.38,2.58-1.16.66-.79.99-1.9.99-3.34v-8.69h3.51v15.65h-3.31v-2.04h-.06c-.53.74-1.19,1.32-1.98,1.75-.79.43-1.7.65-2.72.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m834.49,49.5c.4,0,.82.05,1.27.14v3.11c-.38-.07-.79-.11-1.22-.11-1.4,0-2.48.44-3.23,1.3-.76.87-1.13,2.12-1.13,3.74v7.67h-3.51v-15.65h3.28v2.32h.06c1.03-1.68,2.53-2.52,4.47-2.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m844.57,62.66c.45,0,.81-.04,1.08-.14v2.75c-.62.18-1.27.28-1.95.28-1.66,0-2.87-.38-3.62-1.13-.76-.75-1.13-1.98-1.13-3.68v-8.35h-2.6v-2.69h2.6v-3.91h3.51v3.91h3.06v2.69h-3.06v7.81c0,.89.16,1.52.48,1.9.34.38.88.57,1.64.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m854.13,49.24c2,0,3.54.47,4.64,1.39,1.11.91,1.68,2.22,1.7,3.93h-3.4c0-.92-.25-1.61-.76-2.07-.51-.47-1.25-.71-2.21-.71-.83,0-1.47.17-1.92.51-.45.33-.68.78-.68,1.36,0,.42.11.76.34,1.02.24.27.59.47,1.05.62.45.16,1.17.35,2.15.59,1.36.34,2.41.67,3.17.96.75.3,1.39.79,1.92,1.47.54.67.82,1.57.82,2.72,0,1.44-.59,2.59-1.78,3.45-1.19.86-2.77,1.3-4.75,1.3-2.15,0-3.82-.47-5.01-1.42-1.17-.96-1.77-2.36-1.78-4.19h3.57c0,.96.28,1.71.85,2.24.57.51,1.37.76,2.43.76.88,0,1.57-.17,2.07-.51.51-.35.76-.83.76-1.44,0-.51-.13-.91-.4-1.19-.27-.3-.65-.54-1.16-.71-.51-.18-1.3-.41-2.38-.68-1.23-.3-2.18-.58-2.86-.85-.68-.28-1.27-.72-1.78-1.33-.5-.62-.74-1.48-.74-2.58,0-.92.25-1.73.76-2.43.52-.71,1.25-1.26,2.18-1.64.92-.4,1.99-.59,3.2-.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m409.65,93.54c2.22,0,3.93.55,5.12,1.64,1.2,1.1,1.81,2.57,1.81,4.42s-.61,3.33-1.81,4.42c-1.19,1.1-2.9,1.64-5.12,1.64h-3.71v7.25h-3.28v-19.36h6.99Zm-3.71,9.37h3.34c1.34,0,2.33-.28,2.97-.85.66-.58.99-1.4.99-2.46s-.33-1.87-.99-2.43c-.64-.58-1.63-.88-2.97-.88h-3.34v6.62Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m425.01,111.03c.86,0,1.57-.21,2.12-.62.54-.41.89-.97,1.05-1.67h3.17c-.27,1.3-.96,2.39-2.09,3.25-1.12.87-2.53,1.3-4.25,1.3-1.38,0-2.58-.31-3.59-.93-1-.62-1.78-1.49-2.32-2.6-.53-1.13-.79-2.44-.79-3.93,0-1.36.26-2.58.79-3.65.52-1.09,1.29-1.94,2.29-2.55,1.02-.62,2.21-.93,3.57-.93,1.54,0,2.87.42,3.96,1.27,1.09.83,1.84,1.97,2.24,3.42.24.81.37,1.89.37,3.23h-10.13c.06,1.49.41,2.6,1.08,3.34.66.72,1.51,1.08,2.55,1.08Zm-.06-10.05c-.96,0-1.75.31-2.38.93-.62.61-1,1.49-1.13,2.66h6.99c-.11-1.17-.48-2.05-1.1-2.66-.62-.62-1.42-.93-2.38-.93Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m441.41,98.91c.35,0,.74.04,1.13.11v2.75c-.34-.06-.7-.08-1.08-.08-1.23,0-2.17.39-2.83,1.16-.67.76-.99,1.85-.99,3.28v6.76h-3.11v-13.81h2.89v2.04h.06c.92-1.47,2.24-2.21,3.93-2.21Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m460,112.9v-1.9h-.06c-.4.7-.96,1.25-1.7,1.64s-1.54.59-2.41.59c-1.15,0-2.17-.3-3.06-.88-.87-.6-1.54-1.45-2.01-2.55-.47-1.09-.71-2.36-.71-3.82s.23-2.72.71-3.82c.47-1.09,1.14-1.93,2.01-2.52.86-.6,1.88-.91,3.03-.91.86,0,1.66.19,2.38.57.71.38,1.27.91,1.67,1.58h.06v-7.36h3.09v19.36h-3Zm-3.25-11.75c-1.06,0-1.9.45-2.52,1.33-.61.87-.91,2.04-.91,3.51s.3,2.65.91,3.54c.62.87,1.46,1.3,2.52,1.3,1,0,1.8-.43,2.41-1.3.62-.86.93-2.04.93-3.54s-.31-2.69-.93-3.54c-.61-.86-1.41-1.3-2.41-1.3Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m472.72,111.03c.86,0,1.57-.21,2.12-.62.54-.41.89-.97,1.05-1.67h3.17c-.27,1.3-.96,2.39-2.09,3.25-1.12.87-2.53,1.3-4.25,1.3-1.38,0-2.58-.31-3.59-.93-1-.62-1.78-1.49-2.32-2.6-.53-1.13-.79-2.44-.79-3.93,0-1.36.26-2.58.79-3.65.52-1.09,1.29-1.94,2.29-2.55,1.02-.62,2.21-.93,3.57-.93,1.54,0,2.87.42,3.96,1.27,1.09.83,1.84,1.97,2.24,3.42.24.81.37,1.89.37,3.23h-10.13c.06,1.49.41,2.6,1.08,3.34.66.72,1.51,1.08,2.55,1.08Zm-.06-10.05c-.96,0-1.75.31-2.38.93-.62.61-1,1.49-1.13,2.66h6.99c-.11-1.17-.48-2.05-1.1-2.66-.62-.62-1.42-.93-2.38-.93Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m487.99,95.72c-.68,0-1.18.18-1.5.54-.33.36-.48.93-.48,1.73v1.1h2.66v2.38h-2.66v11.43h-3.09v-11.43h-2.32v-2.38h2.32v-1.47c0-1.39.35-2.45,1.05-3.17.71-.71,1.76-1.08,3.14-1.08.45,0,1,.06,1.64.17v2.29c-.27-.07-.52-.11-.76-.11Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496.77,111.03c.86,0,1.57-.21,2.12-.62.54-.41.89-.97,1.05-1.67h3.17c-.27,1.3-.96,2.39-2.09,3.25-1.12.87-2.53,1.3-4.25,1.3-1.38,0-2.58-.31-3.59-.93-1-.62-1.78-1.49-2.32-2.6-.53-1.13-.79-2.44-.79-3.93,0-1.36.26-2.58.79-3.65.52-1.09,1.29-1.94,2.29-2.55,1.02-.62,2.21-.93,3.57-.93,1.54,0,2.87.42,3.96,1.27,1.09.83,1.84,1.97,2.24,3.42.24.81.37,1.89.37,3.23h-10.13c.06,1.49.41,2.6,1.08,3.34.66.72,1.51,1.08,2.55,1.08Zm-.06-10.05c-.96,0-1.75.31-2.38.93-.62.61-1,1.49-1.13,2.66h6.99c-.11-1.17-.48-2.05-1.1-2.66-.62-.62-1.42-.93-2.38-.93Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m513.42,98.77c1.58,0,2.81.48,3.68,1.44.88.96,1.33,2.37,1.33,4.22v8.46h-3.09v-8.18c0-2.3-.93-3.45-2.8-3.45-.93,0-1.68.35-2.26,1.05-.59.68-.88,1.66-.88,2.92v7.67h-3.11v-13.81h2.94v1.81h.06c.45-.66,1.03-1.17,1.73-1.56.71-.38,1.51-.57,2.41-.57Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m531.24,112.9v-1.9h-.06c-.4.7-.96,1.25-1.7,1.64s-1.54.59-2.41.59c-1.15,0-2.17-.3-3.06-.88-.87-.6-1.54-1.45-2.01-2.55-.47-1.09-.71-2.36-.71-3.82s.23-2.72.71-3.82c.47-1.09,1.14-1.93,2.01-2.52.86-.6,1.88-.91,3.03-.91.86,0,1.66.19,2.38.57.71.38,1.27.91,1.67,1.58h.06v-7.36h3.09v19.36h-3Zm-3.25-11.75c-1.06,0-1.9.45-2.52,1.33-.61.87-.91,2.04-.91,3.51s.3,2.65.91,3.54c.62.87,1.46,1.3,2.52,1.3,1,0,1.8-.43,2.41-1.3.62-.86.93-2.04.93-3.54s-.31-2.69-.93-3.54c-.61-.86-1.41-1.3-2.41-1.3Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m543.37,98.69c1.85,0,3.25.45,4.22,1.36.98.91,1.47,2.26,1.47,4.05v5.15c0,1.49.12,2.71.37,3.65h-2.8c-.13-.57-.2-1.2-.2-1.92h-.06c-1.02,1.49-2.57,2.24-4.64,2.24-1.42,0-2.55-.38-3.4-1.16-.85-.77-1.27-1.75-1.27-2.94s.4-2.13,1.19-2.83c.81-.71,2.18-1.22,4.1-1.53,1.15-.21,2.39-.34,3.74-.4v-.57c0-.96-.25-1.67-.74-2.12-.47-.47-1.13-.71-1.98-.71s-1.49.22-1.95.65c-.47.44-.73,1.02-.76,1.75h-3.03c.07-1.37.6-2.5,1.58-3.37.98-.86,2.36-1.3,4.16-1.3Zm2.72,7.67c-1.19.06-2.26.17-3.2.34-1,.17-1.71.42-2.12.74-.4.33-.59.81-.59,1.44s.21,1.13.62,1.5c.43.36,1.05.54,1.84.54.49,0,.95-.07,1.39-.23.43-.15.8-.38,1.1-.71.35-.38.6-.77.74-1.19.15-.43.23-1.02.23-1.75v-.68Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m559.99,98.77c1.58,0,2.81.48,3.68,1.44.88.96,1.33,2.37,1.33,4.22v8.46h-3.09v-8.18c0-2.3-.93-3.45-2.8-3.45-.93,0-1.68.35-2.26,1.05-.59.68-.88,1.66-.88,2.92v7.67h-3.11v-13.81h2.94v1.81h.06c.45-.66,1.03-1.17,1.73-1.56.71-.38,1.51-.57,2.41-.57Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m574.39,110.52c.4,0,.71-.04.96-.11v2.41c-.57.17-1.15.25-1.75.25-1.47,0-2.54-.33-3.2-.99-.67-.66-.99-1.74-.99-3.25v-7.36h-2.29v-2.38h2.29v-3.45h3.11v3.45h2.69v2.38h-2.69v6.91c0,.78.14,1.33.42,1.67.28.33.76.48,1.44.48Z",
    style: {
      fill: "#999"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfographics1);
export default __webpack_public_path__ + "static/media/infographics-1.19015992c50659875f401eb934cf87a7.svg";
export { ForwardRef as ReactComponent };